import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { auth, appStorage } from "../../firebase";
import companiesQuery from "../../firestore/Companies.query";
import { Company, initialCompany } from "../../model/Companies";
import { Spiner } from "../../components/spinner/Spiner";
import { MunicipalitiesRef } from "./MunicipalitiesRef";
import { UserRecord } from "firebase-admin/lib/auth/user-record";
import authApi from "../../api/Auth.api";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import Button, { BtnProps } from "../../components/button/Button";
import { ChevronLeftIcon, DocumentArrowUpIcon } from "@heroicons/react/24/solid";
import { StackedItem, StackedLists } from "../../components/stackedLists/StackedLists";
import { StaffEditModal } from "./StaffEditModal";
import { StaffRef } from "./StaffRef";
import { AuthUser, Pass, newAuthUser } from "../../model/Auth";
import { Result } from "../../model/Result";
import ExcelJS from "exceljs";
import { Progress } from "../../components/progress/Progress";
import userQuery from "../../firestore/User.query";
import { APP_USE, AttendingGroups, GetAppUseStateFromUserData, GroupsSetting, sanitizeUsers, User, UserCountList, UserData, UserItemMaping } from "../../model/Users";
import { Groups } from "../../model/Groups";
import InputFile from "../../components/input/InputFile";
import { ModalAndAlmightyDialog } from "../../components/modal/ModalAndAlmightyDialog";
import { useNavigate } from "react-router-dom";
import systemParametersQuery  from "../../firestore/SystemParameters.query";
import { exportLogging } from "../../api/exportLogging";
import { convertDateToStringCompactFormat } from "../../utility/ConvertUtily";
import { ConstMessage, SessionKey } from "../../config/const";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { LoginPdfCreateState, FileData } from "../../model/Systemparameters";
import { convertDateTimeToString, zeroPadding } from "../../utility/ConvertUtily";
import { getDownloadURL, ref } from "firebase/storage";
import { requestLoginInfoPDFRecreate } from "../../api/SystemParameters.api";
import { SearchKeys } from "../../model/SearchKeys";
import { regexKanaAlpNum } from "../../utility/ValidationUtilty";
import { convertDateToSlashTypeString } from "../../utility/ConvertUtily";
import { getImportErrorFileNamePrefix } from "../../utility/CommonUtility";
import { checkOption, isOptionActive } from "../../controller/OptionController";
import { Staff } from "../../model/Staff";
import { requestBulkUpdateUsers, requestGetUser, updatepointAssignmentAuthorityData } from "../../api/Users.api";

export const MunicipalitiesInfo = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const isDisabled = useRef(false);

  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;
  const tenantId = currentUser?.tenantId;

  const [isOpenStaff, setIsOpenStaff] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isImport, setIsImport] = useState(false);
  const [dialogTitle, setDialogTitle] = useState<string>('');
  const [dialogChildren, setDialogChildren] = useState<React.ReactNode | undefined>();
  const [dialogActions, setDialogActions] = useState<BtnProps[]>([]);
  const [authUserAndPass, setAuthUserAndPass] = useState<AuthUser & Pass>(newAuthUser);
  const [company, setCompany] = useState<Company>(initialCompany);
  const [groupList, setGroupList] = useState<Groups[]>();
  const [attendingGroupList, setAttendingGroupList] = useState<AttendingGroups[]>();
  const [staffList, setStaffList] = useState<UserRecord[]>([]);
  const [selectStaff, setSelectStaff] = useState<UserRecord>();
  const [progressSubText, setProgressSubText] = useState<string>('');
  const [isInfoType, setIsInfoType] = useState<"company" | "staff">("company");
  const [isUpdateStaff, setIsUpdateStaff] = useState(false);
  const [loadProgress, setLoadProgress] = useState<number>(-1);
  const [loadType, setLoadType] = useState<"csv" | "xlsx">("csv");
  const [isLode, setIsLode] = useState(true);
  const [isStandBy, setIsStandBy] = useState(true);
  const [targetFile, setTargetFile] = useState<File>();
  const [fileDataInfo, setFileDataInfo] = useState<any[]>([]);
  const [loginPdfCreateStateList, setLoginPdfCreateStateList] = useState<LoginPdfCreateState[]>([]);
  const increasePDFCreateFlgRef = useRef(false);
  const [searchKeyList, setSearchKeyList] = useState<SearchKeys[]>();
  const [isLoadModal, setIsLoadModal] = useState(false);
  const [optionFlg, setOptionFlg] = useState<{ point: boolean }>({
    point: false
  });
  const [excelImportType, setExcelImportType] = useState<"userInfo" | "option" | "">("");
  const [userCountList, setUserCountList] = useState<UserCountList>({
    idRegistered: 0,
    usable: 0,
    unusable: 0,
    suspended: 0,
  });

  /** 利用者取込：生年月日 */
  const COL_NUM_BIRTHDAY = 5;
  /** 利用者取込：性別 */
  const COL_NUM_SEX = 6;
  /** 利用者取込：電話番号 */
  const COL_NUM_TEL = 7;
  /** 利用者取込：FAX番号 */
  const COL_NUM_FAX = 8;
  /** 利用者取込：役割 */
  const COL_NUM_ADMIN = 14;
  /** 利用者取込：アプリ利用 */
  const COL_NUM_ACCOUNT = 15;
  /** 利用者取込：郵便番号 */
  const COL_NUM_ZIP = 16;
  /** 利用者取込：検索キー1 */
  const COL_NUM_SEARCH_KEY_1 = 18;
  /** 利用者取込：検索キー2 */
  const COL_NUM_SEARCH_KEY_2 = 19;
  /** 利用者取込：検索キー3 */
  const COL_NUM_SEARCH_KEY_3 = 20;

  useEffect(() => {
    const f = async () => {
      try {
        // 団体を取得
        const company = await companiesQuery.getCompany(tenantId!);
        setCompany(company);

        // 団体に紐づく未完了の利用者作成ステートを取得
        const state = await systemParametersQuery.getCreateState(company.id) ? true : false;
        setIsStandBy(state);

        // 団体のグループ取得
        const groupList = await companiesQuery.getTenantGroups(tenantId!);
        setGroupList(groupList);

        // 団体の検索キーを取得
        const searchKeyList = await companiesQuery.getSearchKeys(tenantId!);
        setSearchKeyList(searchKeyList);

        // 各契約数取得
        const userCountList = await userQuery.getCompanyUserCounts(company.id);
        setUserCountList(userCountList);

        // 管理者リスト取得
        const staffWithUserList = await authApi.requestGetStaff(tenantId!);
        if (staffWithUserList.success) {
          const staffList = staffWithUserList.data.filter((item: Staff) => item.email !== undefined)
          setStaffList(staffList);
        } else {
          throw new Error(staffWithUserList.data);
        }

        // ログイン情報PDF出力ステート一覧取得
        const loginPdfCreateStateList = await systemParametersQuery.getLoginPdfCreateState(company.id) as LoginPdfCreateState[];
        setLoginPdfCreateStateList(loginPdfCreateStateList);

      } catch (err: any) {
        let errorMessage = err.error;
        if (errorMessage === "ERR_NETWORK") {
          dispatch(
            alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
          );
        } else {
          dispatch(alertOpen(AlertValue("失敗しました", "danger")));
        }
      }
      setIsLode(false);
    }
    f();
  },[dispatch, tenantId]);

  //利用者オプション設定出し分け
  async function fetchOptions() {
    const options = await companiesQuery.getOptionContractList(currentUser?.tenantId!);
    // ポイント管理のステータス、期間チェック
    const pointOption = options.find((option) => option.optionId === 'point');
    const point = pointOption ? isOptionActive(pointOption) : false;
    return { point };
  }

  useEffect(() => {
    async function loadOptions() {
      const result = await fetchOptions();
      setOptionFlg(result);
    }
  
    loadOptions();
  }, []);

  // インポート完了ダイアログ用プロパティ
  useEffect(() => {
    if(loadProgress >= 100 && isImport) {
      const successCnt = fileDataInfo.filter((item) => item.status === "success").length;
      const failedCnt = fileDataInfo.filter((item) => item.status === "failed").length;
      if(failedCnt === 0) {
        // 取込NGなし
        const actions: BtnProps[] = [
          {
            color: "indigo",
            children: "OK",
            onClick: () => {
              setIsOpenDialog(false);
              initDialog();
            }
          },
        ];

        let dialogTitle = "";
        let dialogChild = undefined;
        if (0 < successCnt) {
          // 取込OKあり
          dialogTitle = ConstMessage.IMPORT_SUCCESS_DIALOG_TITLE;
          dialogChild = (<>
            <div>{ConstMessage.IMPORT_SUCCESS_DIALOG_TEXT.replace('%1', successCnt.toString())}</div></>);
        } else {
          // 取込なし
          dialogTitle = ConstMessage.IMPORT_NO_DATA_TITLE;
        }

        setIsImport(false);
        setIsOpenDialog(true);
        setDialogTitle(dialogTitle);
        setDialogChildren(dialogChild);
        setDialogActions(actions);
        setLoadProgress(-1);
      } else {
        // 取込NGあり
        const actions: BtnProps[] = [
          {
            color: "indigo",
            children: "ファイルのダウンロード",
            onClick: () => {
              setIsOpenDialog(false);
              setProgress(0);
              excelImportType === "userInfo" ? downloadErrorFile().then(() => {
                setProgress(100);
                setTargetFile(undefined);
                setFileDataInfo([]);
                initDialog();
              })
              : downloadOptionErrorFile().then(() => {
                setProgress(100);
                setTargetFile(undefined);
                setFileDataInfo([]);
                initDialog();
              });
            }
          },
        ];

        const dialogTitle = 0 < successCnt ? ConstMessage.IMPORT_FAILED_DIALOG_TITLE : ConstMessage.IMPORT_FAILED_ALL_DIALOG_TITLE;
        const dialogChild = (<>
          {0 < successCnt ?
            <>
              <div>{ConstMessage.IMPORT_FAILED_DIALOG_TEXT.replace('%1', successCnt.toString()).replace('%2', failedCnt.toString())}</div><br/>
            </> : <>
              <div>{ConstMessage.IMPORT_FAILED_ALL_DIALOG_TEXT.replace('%1', failedCnt.toString())}</div><br/>
            </>
          }
          <div className={'text-red-500 whitespace-pre'}>{ConstMessage.IMPORT_FAILED_DIALOG_TEXT_WORNING}</div>
        </>);

        setIsImport(false);
        setIsOpenDialog(true);
        setDialogTitle(dialogTitle);
        setDialogChildren(dialogChild);
        setDialogActions(actions);
        setLoadProgress(-1);
      }
    }
  }, [loadProgress, isImport, fileDataInfo]);

  const onClickEvent = (item: UserRecord) => {
    setIsInfoType("staff");
    setSelectStaff(item);
    const authUserAndPass: AuthUser & Pass = {
      uid: item.uid,
      photoUrl: item.photoURL ?? '',
      displayName: item.displayName ?? '',
      email: item.email ?? '',
      tenantId: item.tenantId ?? '',
    }
    setAuthUserAndPass(authUserAndPass);
  };

  const onClickStaffAdd = () => {
    setIsUpdateStaff(false);
    setAuthUserAndPass(newAuthUser());
    setIsInfoType("company");
    toggleStaff();
  }

  // スタッフ一覧
  const rowList: StackedItem[] = staffList.map<StackedItem>((item) => {
    // TODO: 検索のためにStateにする
    return {
      value: item,
      isSelected: item === selectStaff,
      event: () => onClickEvent(item),
    };
  });
  // メール再送
  const sendMail = async () => {
    if(!isDisabled.current){
      try {
        isDisabled.current = true;
        const result = await authApi.requestTenantSendEmail(tenantId!, selectStaff?.email!);
        if(result.success){
          dispatch(alertOpen(AlertValue("送信しました", "success")));
          isDisabled.current = false;
        } else {
          throw new Error();
        }
      } catch (err: any) {
        console.error(err)
        dispatch(alertOpen(AlertValue("送信に失敗しました", "danger")));
        isDisabled.current = false;
      }
    }
  }
  // パスワード再設定
  const resetPassword = async () => {
    await authApi.requestTenantSendPasswordResetEmail(tenantId!, selectStaff?.email!)
      .then((resp) => {
        // メール送信成功
        dispatch(
          alertOpen(AlertValue("変更メールを送信しました。", "success"))
        );
      })
      .catch((error) => {
        // メール送信失敗
        dispatch(alertOpen(AlertValue("変更メールを送信に失敗しました", "danger")));
        console.error(error);
      });
    return;
  }


  // スタッフ登録・編集用
  // toggleStaff
  // onClickDeleteStaff
  // onSubmitStaff
  //
  const toggleStaff = () => {
    setIsOpenStaff(!isOpenStaff);
  };
  const onClickDeleteStaff = async () =>{
    if(!isDisabled.current){
      try {
        isDisabled.current = true;
        const authUser: AuthUser = {
          uid: selectStaff?.uid ?? '',
          photoUrl: selectStaff?.photoURL ?? '',
          displayName: selectStaff?.displayName ?? '',
          tenantId: tenantId!,
          email: selectStaff?.email ?? '',
        }
        const result: Result = await authApi.requestDeleteStaff(authUser, tenantId!);
        if (result.success) {
          dispatch(alertOpen(AlertValue("削除しました。", "success")));
          isDisabled.current = false;
        } else {
          throw new Error();
        }
      } catch (err: any) {
        let errorMessage = err.error;
        if (errorMessage === "ERR_NETWORK") {
          dispatch(
            alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
          );
        } else {
          dispatch(alertOpen(AlertValue("削除に失敗しました", "danger")));
        }
        isDisabled.current = false;
      }
    }
  };
  const onSubmitStaff = async (auth: AuthUser & Pass) => {
    if(!isDisabled.current){
      try {
        isDisabled.current = true;

        // 登録済の管理者を取得
        const tenantStaffList = await authApi.requestGetStaff(tenantId!);
        if (!tenantStaffList.success) throw new Error("保存に失敗しました。");

        if(isUpdateStaff){
          // 更新
          auth.uid = authUserAndPass?.uid ?? '';
          auth.tenantId = authUserAndPass?.tenantId ?? '';

          const duplicateStaffList = tenantStaffList.data.filter((item: UserRecord) => item.uid !== auth.uid && item.email === auth.email);
          if (0 < duplicateStaffList.length) {
            // uidが異なる かつ emailが同一 の管理者が存在する場合は保存しない
            sessionStorage.setItem(SessionKey.HAS_DUPLICATED_STAFF_MAIL, "true");
            return;
          }

          // 更新処理
          const result: Result = await authApi.requestUpdateStaff(auth, tenantId!);
          if (result.success) {
            dispatch(alertOpen(AlertValue("保存しました。", "success")));
            toggleStaff();

            // ログインユーザを更新した場合は、ログイン画面に遷移
            if(currentUser?.email === selectStaff?.email){
              navigation('/login');
            }
          } else {
            throw new Error("保存に失敗しました。");
          }

        } else {
          // 新規
          const duplicateStaffList = tenantStaffList.data.filter((item: UserRecord) => item.email === auth.email);
          if (0 < duplicateStaffList.length) {
            // emailが同一 の管理者が存在する場合は保存しない
            sessionStorage.setItem(SessionKey.HAS_DUPLICATED_STAFF_MAIL, "true");
            return;
          }

          // 登録処理
          const result: Result = await authApi.requestCreateStaff(auth, tenantId!);
          if (result.success) {
            dispatch(alertOpen(AlertValue("保存しました。", "success")));
            toggleStaff();
          } else {
            throw new Error("保存に失敗しました。");
          }
        }

        setAuthUserAndPass(auth);
      } catch (err: any) {
        let errorMessage = err.error;
        if (errorMessage === "ERR_NETWORK") {
          dispatch(
            alertOpen(AlertValue(ConstMessage.ERR_CONNECT_TO_NETWORK, "danger"))
          );
        } else {
          dispatch(alertOpen(AlertValue(ConstMessage.ERR_SAVE, "danger")));
        }

      } finally {
        isDisabled.current = false;
      }
    }
  };

  // CSV・Excel出力用
  // onExportAll
  // onExportArea
  const exportAllWarningMessage = (<div className={'text-red-500'}>
    ※Excel出力は、ID数によって<span className={"font-bold text-red-700"}>作業時間が長時間になる場合があります。</span>
  </div>);
  const exportWarningMessage = (<div className={'text-red-500'}>※一度実行すると中止することはできません。</div>);
  // カラム設定
  const column = [
    { header: "No.", key: "no" },
    { header: "利用者番号＊", key: "id" },
    { header: "氏名＊", key: "lastName" },
    { header: "カナ", key: "lastNameKana" },
    { header: "生年月日", key: "birthDate"},
    { header: "性別", key: "sex"},
    { header: "電話番号", key: "phoneNumber"},
    { header: "FAX番号", key: "faxNumber"},
    { header: "配信先1", key: "familyEmail"},
    { header: "配信先2", key: "familyEmail2"},
    { header: "配信先3", key: "familyEmail3"},
    { header: "配信先4", key: "familyEmail4"},
    { header: "配信先5", key: "familyEmail5"},
    { header: "役割＊", key: "admin"},
    { header: "アプリ利用＊", key: "deleteFlg"},
    { header: "郵便番号", key: "zipCode"},
    { header: "住所", key: "address"},
    { header: "検索キー1", key: "searchKey1"},
    { header: "検索キー2", key: "searchKey2"},
    { header: "検索キー3", key: "searchKey3"},
    { header: "備考", key: "note"}
  ];
  // 注釈設定
  const annotation = [
    ["※団体番号、利用者番号の変更、追加はできません。"], // 2行目
    ["※入力方法については、マニュアルをご参照ください。"], // 3行目
    ["※＊は必須項目のため、必ず入力してください。"], // 4行目
  ];

  const onExportAll = (format: 'csv' | 'xlsx', type: 'info' | 'option') => {
    // エクスポート前確認ダイアログ
    const actions: BtnProps[] = [
      {
        color: "indigo",
        outline: true,
        children: "キャンセル",
        className:"w-[132px]",
        onClick: () => {
          setIsOpenDialog(false);
          initDialog();
        }
      },
      {
        color: "indigo",
        children: "OK",
        className:"w-[132px]",
        onClick: () => {
          if(type === 'info'){
            exportAll(format);
          } else if (type === 'option') {
            exportOption(format);
          }
          setIsOpenDialog(false);
          initDialog();
        }
      },
    ];
    const dialogChildren = (<>
      以下のExcelファイルを出力します。
      <ul className={`list-disc m-2 text-${format === 'xlsx' ? 'green' : 'yellow' }-700`}>
        <li className={"flex"}><DocumentArrowUpIcon className={"h-6 w-6"}/>{type === 'info' ? '利用者情報' : '利用者オプション設定'}_{company.name}_{convertDateToStringCompactFormat(new Date())}.{format}</li>
      </ul>
      {exportAllWarningMessage}
      {exportWarningMessage}
    </>)
    setIsImport(false);
    setIsOpenDialog(true);
    setDialogTitle("Excel一括出力確認");
    setDialogChildren(dialogChildren);
    setDialogActions(actions);
  }

  // 利用者情報出力
  const exportAll = async (format: 'csv' | 'xlsx') => {
    console.time("Excel出力");

    // 一括出力
    setLoadType(format);

    // プログレスバー更新
    setLoadProgress(0);
    setProgressSubText(ConstMessage.PROGRESS_SUB_TEXT);

    const filePath = "format/usersOutput/利用者情報_団体入力用テンプレート.xlsx";
    const fileRef = ref(appStorage, `${process.env.REACT_APP_GC_BUCKET_NAME}/${filePath}`);
    const url = await getDownloadURL(fileRef);
    const response = await fetch(url);

    const arrayBuffer = await response.arrayBuffer();
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(arrayBuffer);
    const worksheet = workbook.getWorksheet('入力データ');
    worksheet.getCell("C1").value = company.displayId;
    
    const headerRow = worksheet.getRow(5);
    const headers = headerRow.values as string[];

    const fieldMapping: { [key: string]: string } = {
      "利用者番号＊": "id",
      "氏名＊": "lastName",
      "カナ": "lastNameKana",
      "生年月日": "birthDate",
      "性別": "sex",
      "電話番号": "phoneNumber",
      "FAX番号": "faxNumber",
      "配信先1": "familyEmail",
      "配信先2": "familyEmail2",
      "配信先3": "familyEmail3",
      "配信先4": "familyEmail4",
      "配信先5": "familyEmail5",
      "役割＊": "admin",
      "アプリ利用＊": "deleteFlg",
      "郵便番号": "zipCode",
      "住所": "address",
      "検索キー1": "searchKey1",
      "検索キー2": "searchKey2",
      "検索キー3": "searchKey3",
      "備考": "note",
      "所属グループ": "group",
    };

    const allUsers: any[] = [];
    let page = 1;
    let hasMore = true;
    const pageSize = 5000;
    let totalCount = 0;

    // 利用者取得
    while (hasMore) {
      const result = await requestGetUser(page, pageSize, { tenantId: tenantId! });
      if (!result.success) {
        console.error("ユーザー取得に失敗", result.error);
        break;
      }
      if (page === 1) {
        totalCount = result.totalCount ?? 0;
      }
      allUsers.push(...result.users);
      hasMore = result.users.length === pageSize;
      // 進捗更新
      const progressRate = Math.round((allUsers.length / totalCount) * 50);
      setLoadProgress(progressRate);
      page++;
      await new Promise(resolve => setTimeout(resolve, 0));
    }

    // 全件取得完了後、maxGroupCount算出
    let maxGroupCount = 0;
    for (const user of allUsers) {
      const count = Number(user.groupCount ?? 0);
      if (count > maxGroupCount) maxGroupCount = count;
    }

    // グループ列の定義（確定版）
    const column: { header: string; key: string }[] = [];
    const groupCountForColumn = Math.max(10, maxGroupCount);
    for (let i = 1; i <= groupCountForColumn; i++) {
      column.push({
        header: i === 1 ? "所属グループ" : "",
        key: `group${i}`,
      });
    }

    // 全ユーザー出力処理
    let currentRowIndex = 7;
    for (const user of allUsers) {
      const convUser = UserItemMaping(user); 
      const appUse = GetAppUseStateFromUserData(convUser); 
      // 所属グループ
      const groupNameList = user.groups.map((g: { name: any; }) => g.name);
      // 誕生日を変換
      const birthDate = Number.isNaN(convUser.birthDate?.getTime()) ? undefined : convUser.birthDate;
      const familyEmails = String(convUser.familyEmail ?? '').split(',');
      interface InsertData {
        [key: string]: string | undefined; 
      }
      
      const insertData: InsertData = {
        id: convUser.id.replace(company.displayId, ''),
        passCode: "",//showPassword,
        lastName: convUser.lastName,
        lastNameKana: convUser.lastNameKana,
        birthDate: birthDate !== undefined ? convertDateToSlashTypeString(birthDate) : '',
        sex: convUser.sex !== undefined ? (convUser.sex === 0 ? "男" : convUser.sex === 1 ? "女" : "その他") : '',
        phoneNumber: convUser.phoneNumber,
        faxNumber: convUser.faxNumber,
        familyEmail: familyEmails[0] || '',
        familyEmail2: familyEmails[1] || '',
        familyEmail3: familyEmails[2] || '',
        familyEmail4: familyEmails[3] || '',
        familyEmail5: familyEmails[4] || '',
        admin: convUser.admin !== undefined ? (convUser.admin ? "運営者" : "利用者") : '',
        deleteFlg: appUse !== undefined ? (appUse === APP_USE.AVAILABLE ? "利用可" : appUse === APP_USE.UNUSEABLE ? "利用不可" : "利用停止") : '',
        zipCode: convUser.zipCode,
        address: convUser.address,
        searchKey1: convUser.searchKey1,
        searchKey2: convUser.searchKey2,
        searchKey3: convUser.searchKey3,
        note: convUser.note,
      };
      const row = worksheet.getRow(currentRowIndex++);
      headers.forEach((header, colIndex) => {
        const fieldName = fieldMapping[header];
        if (fieldName && insertData[fieldName] !== undefined) {
          row.getCell(colIndex).value = insertData[fieldName] ?? null;
        }
      });

       // グループの追加
      const startColumnIndex = 22;
      groupNameList.forEach((groupName: string | number | boolean | Date | ExcelJS.CellErrorValue | ExcelJS.CellRichTextValue | ExcelJS.CellHyperlinkValue | ExcelJS.CellFormulaValue | ExcelJS.CellSharedFormulaValue | null | undefined, idx: number) => {
        const colIndex = startColumnIndex+ idx;
        row.getCell(colIndex).value = groupName;
      });

      const processedRows = currentRowIndex - 10;
      const progressRate = 50 + Math.round((processedRows / allUsers.length) * 20);
      setLoadProgress(progressRate);

      row.commit(); 

      if (processedRows % 90 === 0) {
        await new Promise(resolve => setTimeout(resolve, 0));
      }
    }

    let lastColumn = '';
    let num = 0;
    if(maxGroupCount - 10 > 0) {
      num = 31 + maxGroupCount - 10;
      lastColumn = getLastColumn(num);
    } else {
      num = 32;
      lastColumn = 'AF';
    }
    const startCol = 32;
    const totalRows = worksheet.rowCount;
    for (let row = 5; row <= totalRows; row++) {
      if (row == 5) {
        for (let col = startCol; col <= num; col++) {
          const cell = worksheet.getCell(row, col);
          cell.protection = { locked: true };
          if (cell) {
            cell.style.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D9D9D9' },
            };
            cell.style.border = {
              top: { style: 'thin' },
              bottom: { style: 'thin' },
            };
          }
        }
      } else if (row == 6) {
        for (let col = startCol; col <= num; col++) {
          const cell = worksheet.getCell(row, col);
          cell.protection = { locked: true };
          if (cell) {
            cell.style.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'DCE6F1' },
            };
            cell.style.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
            };
          }
        }
      } else {
        for (let col = startCol; col <= num; col++) {
          const cell = worksheet.getCell(row, col);
          if (cell) {
            cell.style.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
            };
          }
        }
      }
      // 進捗更新
      if (row % 200 === 0 || row === totalRows) {
        const subProgress = 70 + Math.round((row / totalRows) * 10);
        setLoadProgress(subProgress);
        await new Promise(resolve => setTimeout(resolve, 0));
      }
    }

    // 最終列
    worksheet.getColumn(lastColumn).eachCell((cell, rowNumber) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'A5A5A5' },
      };
      if (rowNumber % 1000 === 0) {
        const progressRate = 80 + Math.min(2, Math.round((rowNumber / 50000) * 9));
        setLoadProgress(progressRate);
      }
    });
    worksheet.getCell(`${lastColumn}5`).value = '最終列'
    worksheet.getCell(`${lastColumn}5`).font = {
      name: 'メイリオ',
    };
    worksheet.getCell(`${lastColumn}5`).style.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb :'D9D9D9' },
    }
    worksheet.getCell(`${lastColumn}5`).style.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    
    worksheet.getCell(`${lastColumn}6`).style.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb :'DCE6F1' },
    }
  
    let col = 0;
    if(maxGroupCount - 10 > 0) {
      col = 32 + maxGroupCount - 10;
    } else {
      col = 32;
    }
    for (let row = 6; row <= 50006; row++) {
      worksheet.getCell(row, col).style.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
    for (let row = 1; row <= 6; row++) {
      const cell = worksheet.getCell(`${lastColumn}${row}`);
      cell.protection = { locked: true };
    }

    // ダウンロード処理
    setLoadProgress(90);

    // ダウンロードリンク
    const a = document.createElement("a");
    const bom = "\uFEFF";
    let uint8Array: ArrayBuffer | string;
    if (format === "xlsx") {
      uint8Array = await workbook.xlsx.writeBuffer();
    } else {
      uint8Array = bom + await workbook.csv.writeBuffer();
    }

    setLoadProgress(95);
    const blob = new Blob([uint8Array], { type: "application/octet-binary" });
    a.href = window.URL.createObjectURL(blob);
    a.download = `利用者情報_${company.name}_${convertDateToStringCompactFormat(new Date())}.${format}`;
    a.click();
    a.remove();

    setLoadProgress(100);
    // ログ出力
    const date = new Date();
    const data = {
      log_level: "info",
      app_name: "webapp",
      is_audit: true,
      dawnload_date: new Date(date.getTime() + 9 * 60 * 60 * 1000),
      dawnload_user: currentUser?.email,
      tenant_id: tenantId,
      download_filename: a.download,
      message: "利用者一覧Excelファイルダウンロード実行",
    };
    exportLogging(data);
    setLoadProgress(-1);

    console.timeEnd("Excel出力");
  };

  // 利用者オプション設定出力
  const exportOption = async (format: 'csv' | 'xlsx') => {
    console.time("利用者オプションExcel出力");

    // 一括出力
    setLoadType(format);

    // プログレスバー更新
    setLoadProgress(0);
    setProgressSubText(ConstMessage.PROGRESS_SUB_TEXT);

    // 利用者取得
    const allUsers: any[] = [];
    let page = 1;
    let hasMore = true;
    const pageSize = 5000;
    let totalCount = 0;

    while (hasMore) {
      const result = await requestGetUser(page, pageSize, { tenantId: tenantId! });
      if (!result.success) {
        console.error("ユーザー取得に失敗", result.error);
        break;
      }
      if (page === 1) totalCount = result.totalCount ?? 0;
      allUsers.push(...result.users);
      hasMore = result.users.length === pageSize;

      // データ取得進捗（0〜60％）
      const progressRate = Math.round((allUsers.length / totalCount) * 60);
      setLoadProgress(progressRate);
      page++;
      await new Promise(resolve => setTimeout(resolve, 0));
    }

    const adminUserList = allUsers.filter(
      (user) => user.admin !== undefined && user.accountSuspensionFlg !== true
    );

    if (adminUserList.length === 0) {
      dispatch(alertOpen(AlertValue(ConstMessage.ERR_OPTION_SETTING_USER_NO_DATA, "danger")));
      setLoadProgress(-1);
      return;
    }

    const filePath = "format/usersOptionOutput/利用者オプション設定テンプレート.xlsx";
    const fileRef = ref(appStorage, `${process.env.REACT_APP_GC_BUCKET_NAME}/${filePath}`);
    const url = await getDownloadURL(fileRef);
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(arrayBuffer);
    const worksheet = workbook.getWorksheet('入力データ');
    worksheet.getCell("C1").value = company.displayId;

    const headerRow = worksheet.getRow(5);
    const headers = headerRow.values as string[];

    const fieldMapping: { [key: string]: string } = {
      "利用者番号": "id",
      "*氏名": "lastName",
      "*役割": "admin",
      "ポイント管理": "pointAssignmentAuthority",
    };

    const startRow = 7;
    for (let index = 0; index < adminUserList.length; index++) {
      const user = adminUserList[index];
      const convUser = UserItemMaping(user);

      interface InsertData {
        [key: string]: string | undefined;
      }

      const insertData: InsertData = {
        id: convUser.id.replace(company.displayId, ''),
        lastName: convUser.lastName,
        admin: convUser.admin ? "運営者" : "利用者",
        pointAssignmentAuthority: convUser.pointAssignmentAuthority == null ? '' : convUser.pointAssignmentAuthority ? "利用可" : "利用不可",
      };

      const row = worksheet.getRow(startRow + index);
      headers.forEach((header, colIndex) => {
        const fieldName = fieldMapping[header];
        if (fieldName && insertData[fieldName] !== undefined) {
          row.getCell(colIndex).value = insertData[fieldName] ?? null;
        }
      });
      row.commit();

      if (index % 10 === 0 || index === adminUserList.length - 1) {
        const progressRate = 60 + Math.round((index / adminUserList.length) * 30);
        setLoadProgress(progressRate);
        await new Promise(resolve => setTimeout(resolve, 0));
      }
    }
    setLoadProgress(100);
    // ダウンロードリンク
    const a = document.createElement("a");
    const bom = "\uFEFF";
    const uint8Array = format === "xlsx"
      ? await workbook.xlsx.writeBuffer()
      : bom + await workbook.csv.writeBuffer();
    const blob = new Blob([uint8Array], { type: "application/octet-binary" });
    a.href = window.URL.createObjectURL(blob);
    a.download = `利用者オプション設定_${company.name}_${convertDateToStringCompactFormat(new Date())}.${format}`;
    a.click();
    a.remove();

    const date = new Date();
    exportLogging({
      log_level: "info",
      app_name: "webapp",
      is_audit: true,
      dawnload_date: new Date(date.getTime() + 9 * 60 * 60 * 1000),
      dawnload_user: currentUser?.email,
      tenant_id: tenantId,
      download_filename: a.download,
      message: "利用者オプション設定Excelファイルダウンロード実行"
    });
    setLoadProgress(-1);
    console.timeEnd("利用者オプションExcel出力");
  };

  const getLastColumn = (n: any):string  => {return (n > 25 ? getLastColumn(Math.floor(n / 26 - 1)) : "") + (n % 26 + 10).toString(36).toUpperCase()};

  // CSV・Excel取込用
  // onImportAll
  // onImportArea
  const importWorningMessage = (<div>※Excelに記載した内容で利用者情報を更新します。</div>);
  const importAllWorningMessage = (
    <div className={'text-red-500'}>
      ※Excel取込は、ID数によって<span className={"font-bold text-red-700"}>作業時間が長時間になる場合があります。</span><br/>
      ※一度実行すると中止することはできません。
    </div>);
  const onImportAll = async (
    format: 'csv' | 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsLoadModal(true);
    setExcelImportType("userInfo");
    const fileNameList: string[] = [];
    if(file){
      fileNameList.push(file.name);
    }

    // インポート前確認ボタンアクション
    const getBtnActions = (res: string) => {
      if (res) {
        // エラーがある場合：OKのみ（閉じるのみ）
        const actions: BtnProps[] = [
          {
            color: "indigo",
            children: "OK",
            onClick: () => {
              e.target.value = '';
              setIsOpenDialog(false);
              initDialog();
            }
          },
        ];
        return actions;

      } else {
        // エラーがない場合：OK or キャンセル
        const actions: BtnProps[] = [
          {
            color: "indigo",
            outline: true,
            children: "キャンセル",
            className:"w-[132px]",
            onClick: () => {
              e.target.value = '';
              setIsOpenDialog(false);
              initDialog();
            }
          },
          {
            color: "indigo",
            children: "OK",
            className:"w-[132px]",
            onClick: () => {
              importAll(format, file, e);
              setIsOpenDialog(false);
              initDialog();
            }
          },
        ];
        return actions;
      }
    };

    // インポート前確認ダイアログ
    checkImportAll(format, file, e).then((res) => {
      const importErrorMessage = (
        <div className={'text-red-500'}>
          {res}
        </div>);

      const dialogChildren = (<>
        {res !== null
          ? "ファイルチェックでエラーが発生しました。ファイルを確認してください。"
          : "ファイルチェックが完了しました。以下のExcelファイルの内容を登録しますか？"}
        <ul className={`list-disc m-2 text-${format === 'xlsx' ? 'green' : 'yellow' }-700`}>
          {
            fileNameList.map((name, index) =>
              (<li className={"flex"} key={`fileList-${index}`}><DocumentArrowUpIcon className={"h-6 w-6"}/>{name}</li>))
          }
        </ul>
        {res !== null ? "" : importWorningMessage}
        {res !== null ? "" : importAllWorningMessage}
        {res !== null ? importErrorMessage : ""}
      </>)

      setIsOpenDialog(true);
      setDialogTitle("Excel一括取込確認");
      setDialogChildren(dialogChildren);
      setDialogActions(getBtnActions(res));
    });
  };

  /** 利用者情報　インポート前ファイルチェック */
  const checkImportAll = async (
    format: 'csv' | 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const blobURL = window.URL.createObjectURL(file as Blob);
    const promise = new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      setLoadType(format);
      xhr.onload = async () => {
        const result = xhr.response;
        const data = new Uint8Array(result);
        try{
          const workbook = new ExcelJS.Workbook();
          if(format === 'xlsx'){
            // Excel
            await workbook.xlsx.load(data as any);
          } else {
            // CSV
            await workbook.csv.readFile(result);
          }
          const worksheet = workbook.worksheets[0];
          worksheet.pageSetup = {orientation:'portrait'};
          // ファイル内の団体番号と実行者の団体番号を比較
          const tenantNo = company.displayId;
          const tenantNoRow = worksheet.getRow(1);
          if(tenantNo !== (tenantNoRow.getCell(3).value?.toString() ?? '')){
            throw new Error(ConstMessage.ERR_DIFFERENT_TENANT_ID);
          }
          // n行目から項目リストを取得して正しいファイルか確認
          const columnRowNum = annotation.length + 2;
          const columnHeader = worksheet.getRow(columnRowNum);
          const listHeader = column.map((item) => item.header);
          for (let i = 0; i < column.length; i++){
            if(listHeader[i] !== (columnHeader.getCell(i + 1).value?.toString() ?? '')){
              throw new Error(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
            }
          };
          // 最終列カラムが存在するか確認
          const endLineCol = getTargetCol(columnHeader, '最終列');
          if (endLineCol < 0) {
            throw new Error(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
          }
          setIsLoadModal(false);
          resolve(null);
        } catch (e: any) {
          console.error(e);
          setIsLoadModal(false);
          resolve(e.message);
          // dispatch(alertOpen(AlertValue(e.toString(), "danger")));
        }
      };

      xhr.responseType = "arraybuffer";
      xhr.open("GET", blobURL);
      xhr.send(null);
    });

    return promise;
  };

  /** 利用者情報　一括取込 */
  const importAll = async (
    format: 'csv' | 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoadType(format);
    importData(format, file).then(async (res) => {
      setFileDataInfo(res.data);
      e.target.value = '';
    });
  };

  /** 利用者情報　一括取込処理 */
  const importData = async (
    format: 'csv' | 'xlsx',
    file: File | null
  ) => {
    console.time("Excel取込"); 

    // 初期化用の Map
    const groupUserCountMap: Record<string, number> = {};
    const alreadyRegisteredGroupMap: Record<string, Set<string>> = {};
    const userMap: Record<string, UserData> = {};
    const allUsers: any[] = [];
    let page = 1;
    let hasMore = true;
    const pageSize = 5000;
    let totalCount = 0;

    setIsImport(true);
    setLoadProgress(0);
    setProgressSubText(ConstMessage.PROGRESS_SUB_TEXT);
    setLoadType(format);

    while (hasMore) {
      const result = await requestGetUser(page, pageSize, { tenantId: tenantId! });
      if (!result.success) {
        console.error("ユーザー取得に失敗", result.error);
        break;
      }
      if (page === 1) totalCount = result.totalCount ?? 0;
      allUsers.push(...result.users);
      hasMore = result.users.length === pageSize;
      // 進捗更新（0%〜20%）
      const progressUserFetch = Math.round((allUsers.length / totalCount) * 0.2 * 100);
      setLoadProgress(progressUserFetch);
      page++;
      await new Promise(resolve => setTimeout(resolve, 0));
    }

    // Map 初期化
    allUsers.forEach(user => {
      userMap[company.displayId + user.displayId] = user;
      (user.groups || []).forEach((g: { id: string | number }) => {
        if (!alreadyRegisteredGroupMap[g.id]) alreadyRegisteredGroupMap[g.id] = new Set();
        alreadyRegisteredGroupMap[g.id].add(user.id);
        groupUserCountMap[g.id] = (groupUserCountMap[g.id] || 0) + 1;
      });
    });

    const blobURL = window.URL.createObjectURL(file as Blob);
    return new Promise<any>((resolve) => {
      const xhr = new XMLHttpRequest();

      xhr.responseType = "arraybuffer";
      xhr.open("GET", blobURL);
      xhr.send(null);

      xhr.onload = async () => {
        try {
          const result = xhr.response;
          const data = new Uint8Array(result);
          const workbook = new ExcelJS.Workbook();
          if(format === 'xlsx'){
            // Excel
            await workbook.xlsx.load(data as any);
          } else {
            // CSV
            await workbook.csv.readFile(result);
          }
          const worksheet = workbook.worksheets[0];
          worksheet.columns = column;
          worksheet.pageSetup = {orientation:'portrait'};
          const columnRowNum = annotation.length + 2;
          const columnHeader = worksheet.getRow(columnRowNum);
          const endCol = getTargetCol(columnHeader, '最終列');
          const resultCol = getTargetCol(columnHeader, '取込結果');
          const recordResult: { id: string; status: string; info?: any }[] = [];
          const fileDataInfo: { id: string; status: string; info?: any }[] = [];
          const bulkUpdateList: UserData[] = [];
          const startRow = columnRowNum + 2;
          const targetRowCnt = resultCol >= 0
            ? worksheet.rowCount + 1 - startRow - worksheet.getColumn(resultCol).values.filter((v) => v === "○").length
            : worksheet.rowCount + 1 - startRow;
          let processRowCnt = 0;

          // 順にDBに登録
          for (let i = startRow; i < worksheet.rowCount + 1; i++) {
            processRowCnt++;
            const row = worksheet.getRow(i);
            // 取込結果
            if (resultCol >= 0) {
              // エラーファイルの場合
              const result = row.getCell(resultCol).value?.toString() ?? "";
              if (result === "○") {
                // 読取結果が ○ の場合
                processRowCnt--;
                continue;
              }
            }

            const idVal = row.getCell("id").value;
            if (!idVal) continue;
            const id = idVal.toString();
            const rowData = getRowData(row, endCol);

            const targetRowError = await targetRowDataCheck(
              rowData,
              id,
              groupUserCountMap,
              alreadyRegisteredGroupMap,
              userMap,
              groupList ?? []
            );

            if (targetRowError.length > 0) {
              const failedRecord = { id, status: 'failed', info: targetRowError };
              recordResult.push(failedRecord);
              fileDataInfo.push(failedRecord);
              continue;
            }

            if (!rowData.lastName) {
              const emptyRecord = { id, status: '' };
              recordResult.push(emptyRecord);
              fileDataInfo.push(emptyRecord);
              continue;
            }

            // 新規グループ人数カウント更新（上限1000）
            rowData.groupNameList.forEach(group => {
              const groupItem = groupList?.find(item => item.name === group.name);
              if (!groupItem) return;
              const alreadyRegistered = alreadyRegisteredGroupMap[groupItem.id]?.has(company.displayId + id);
              const currentCount = groupUserCountMap[groupItem.id] || 0;
              if (!alreadyRegistered && currentCount < 1000) {
                groupUserCountMap[groupItem.id] = currentCount + 1;
                alreadyRegisteredGroupMap[groupItem.id]?.add(company.displayId + id);
              }
            });

            const groupsSetting: GroupsSetting[] = rowData.groupNameList.map(item => {
              const groupItem = groupList?.find(g => g.name === item.name);
              return {
                id: groupItem?.id ?? '',
                tenantId: tenantId!,
                name: item.name,
                color: groupItem?.groupColor ?? 'blue',
                updateAt: new Date(),
              } as GroupsSetting;
            });

            const rowDataWithMeta: UserData = {
              id: `${company.displayId}${id}`,
              tenantId: tenantId!,
              lastName: rowData.lastName || "",
              lastNameKana: rowData.lastNameKana || "",
              birthDate: rowData.birthday,
              sex: rowData.sex,
              phoneNumber: rowData.phoneNumber,
              faxNumber: rowData.faxNumber,
              iconURL: "",
              familyEmail: rowData.familyEmail,
              groupCount: 0,
              devicesCount: 0,
              updateAt: new Date(),
              admin: rowData.admin,
              deleteFlg: rowData.deleteFlg,
              accountSuspensionFlg: rowData.accountSuspensionFlg,
              groups: groupsSetting,
              note: rowData.note,
              zipCode: rowData.zipCode,
              address: rowData.address,
              searchKey1: rowData.searchKey1,
              searchKey2: rowData.searchKey2,
              searchKey3: rowData.searchKey3,
            };

            bulkUpdateList.push(rowDataWithMeta);
            const successRecord = { id, status: 'success' };
            recordResult.push(successRecord);
            fileDataInfo.push(successRecord);

            const progressRow = 0.2 + (processRowCnt / targetRowCnt) * 0.1; // 20~30%
            setLoadProgress(Math.round(progressRow * 100));
          }

          const batchSize = 1000;
          if (bulkUpdateList.length > 0) {
            const safeBulkUpdateList = sanitizeUsers(bulkUpdateList);
            const batches = [];
            for (let i = 0; i < safeBulkUpdateList.length; i += batchSize) {
              batches.push(safeBulkUpdateList.slice(i, i + batchSize));
            }

            for (let i = 0; i < batches.length; i++) {
              const batch = batches[i];

              // userMap はこのバッチに含まれるユーザーだけに最小化
              const userMapBatch = batch.reduce<Record<string, UserData>>((map, user) => {
                const original = allUsers.find(u => u.id === user.id);
                if (original) map[user.id] = { ...original, groups: original.groups ?? [] };
                return map;
              }, {});

              try {
                const result = await requestBulkUpdateUsers(tenantId!, batch, company.displayId, userMapBatch);
                if (!result.success) {
                  console.error("Batch failed:", result);
                  break;
                }
              } catch (err) {
                console.error(`Batch error at index ${i}`, err);
                break;
              }

              const progressBatch = 0.3 + ((i + 1) / batches.length) * 0.65; // 70~95%
              setLoadProgress(Math.round(progressBatch * 100));
            }
          }

          // グループ人数更新
          if (groupList && Object.keys(alreadyRegisteredGroupMap).length > 0) {
            for (const group of groupList) {
              const count = alreadyRegisteredGroupMap[group.id]?.size ?? 0;
              await userQuery.updateGroupUserCount(tenantId!, group.id, count);
              group.userCount = count;
            }
          }

          const hasFailed = recordResult.some(r => r.status !== "success");
          setFileDataInfo(fileDataInfo);
          setLoadProgress(100);
          console.timeEnd("Excel取込"); 
          resolve({ status: hasFailed ? "failed" : "success", data: recordResult, fileDataInfo });

        } catch (e: any) {
          console.error(e);
          dispatch(alertOpen(AlertValue(e.toString(), "danger")));
          setLoadProgress(-1);
          resolve({ status: "error", data: e });
        }
      };
    });
  };

  const targetRowDataCheck = async (
    rowData: any,
    targetId: string,
    groupUserCountMap: { [groupId: string]: number },
    alreadyRegisteredGroupMap: { [groupId: string]: Set<string> },
    userMap: { [userId: string]: UserData },
    groupList: Groups[]
  ) => {
    const targetUser = userMap[company.displayId + targetId];
    if (!targetUser) {
      const notFoundErr = [getErrorDataItem('id')];
      return [getErrorData(ConstMessage.IMPORT_ERR_NOT_FOUND_USER, notFoundErr)];
    }
    const convUser = UserItemMaping(targetUser);
    const birthDate = Number.isNaN(convUser.birthDate?.getTime()) ? undefined : convUser.birthDate;

    const targetRowError = [];
    const accountSuspensionErr = [];
    const accountSuspensionSettingErr = [];
    const requiredFieldErr = [];
    const invalidValueErr = [];
    const unregisteredValueErr = [];
    const invalidFormatEmailsCol: number[] = [];
    const invalidFormatErr = [];

    if (GetAppUseStateFromUserData(targetUser) === APP_USE.SUSPEND) {
      // firestore登録値のアプリ利用が「停止」である場合
      // 登録値と入力値を比較する
      if (rowData.lastName !== targetUser.lastName) accountSuspensionErr.push(getErrorDataItem('lastName'));
      if (rowData.lastNameKana !== targetUser.lastNameKana) accountSuspensionErr.push(getErrorDataItem('lastNameKana'));
      if ((birthDate === undefined && rowData.birthday !== undefined) || (birthDate !== undefined && (new Date(rowData.birthday).toDateString() !== new Date(birthDate).toDateString()))) accountSuspensionErr.push(getErrorDataItem('birthDate'));
      if (rowData.sex !== targetUser.sex) accountSuspensionErr.push(getErrorDataItem('sex'));
      if (rowData.phoneNumber !== targetUser.phoneNumber) accountSuspensionErr.push(getErrorDataItem('phoneNumber'));
      if (rowData.faxNumber !== targetUser.faxNumber) accountSuspensionErr.push(getErrorDataItem('faxNumber'));
      const familyEmailArr = targetUser.familyEmail?.split(',');
      if (familyEmailArr?.length === 5) {
        if (rowData.familyEmail1 !== familyEmailArr[0]) invalidFormatEmailsCol.push(getColumnIndex('familyEmail'));
        if (rowData.familyEmail2 !== familyEmailArr[1]) invalidFormatEmailsCol.push(getColumnIndex('familyEmail2'));
        if (rowData.familyEmail3 !== familyEmailArr[2]) invalidFormatEmailsCol.push(getColumnIndex('familyEmail3'));
        if (rowData.familyEmail4 !== familyEmailArr[3]) invalidFormatEmailsCol.push(getColumnIndex('familyEmail4'));
        if (rowData.familyEmail5 !== familyEmailArr[4]) invalidFormatEmailsCol.push(getColumnIndex('familyEmail5'));
        if (invalidFormatEmailsCol.length > 0) {
          accountSuspensionErr.push({colNo: invalidFormatEmailsCol, colName: "イベント参加履歴メール"});
        }
      }
      if (rowData.admin !== targetUser.admin) accountSuspensionErr.push(getErrorDataItem('admin'));
      if (rowData.deleteFlgStr !== "利用停止")  accountSuspensionErr.push(getErrorDataItem('deleteFlg'));
      if ((targetUser.zipCode !== undefined) && (rowData.zipCode !== targetUser.zipCode)) accountSuspensionErr.push(getErrorDataItem('zipCode')); /* 郵便番号 */
      if ((targetUser.address !== undefined) && (rowData.address !== targetUser.address)) accountSuspensionErr.push(getErrorDataItem('address')); /* 住所 */
      if ((targetUser.searchKey1 !== undefined) && (rowData.searchKey1 !== targetUser.searchKey1)) accountSuspensionErr.push(getErrorDataItem('searchKey1')); /* 検索キー1 */
      if ((targetUser.searchKey2 !== undefined) && (rowData.searchKey2 !== targetUser.searchKey2)) accountSuspensionErr.push(getErrorDataItem('searchKey2')); /* 検索キー2 */
      if ((targetUser.searchKey3 !== undefined) && (rowData.searchKey3 !== targetUser.searchKey3)) accountSuspensionErr.push(getErrorDataItem('searchKey3')); /* 検索キー3 */
      if (rowData.note !== targetUser.note) accountSuspensionErr.push(getErrorDataItem('note'));
      const userAttendingGroups = attendingGroupList?.filter(
        (group) => group.userId === targetUser.id);
      const attendingGroupIdList = userAttendingGroups?.map(
        (attendingGroup) => attendingGroup.id);
      const groupNameList = groupList?.filter(
        (group) => attendingGroupIdList?.includes(group.id)
      ).map((group) => group.name);
      rowData.groupNameList.forEach((group: { name: string; col: number; }) => {
        if (groupNameList?.find((target) => target === group.name)?.length?? 0 < 1) {
          accountSuspensionErr.push({colNo: [group.col], colName: "所属グループ"});
        }
      })
    } else {
      // firestore登録値のアプリ利用が「停止」でない場合
      // 停止設定チェック
      if (rowData.deleteFlgStr === "利用停止") accountSuspensionSettingErr.push(getErrorDataItem('deleteFlg'));
      // 無効値チェック
      // 名前、役割、アプリ利用いずれかに入力値がある場合
      if (rowData.lastName !== '' || rowData.adminStr !== '' || rowData.deleteFlgStr !== '') {
        if (rowData.lastName.length === 0)
          requiredFieldErr.push(getErrorDataItem('lastName'));
        if (rowData.adminStr.length === 0)
          requiredFieldErr.push(getErrorDataItem('admin'));
        if ((rowData.adminStr.length > 0) && !(rowData.adminStr === "利用者" || rowData.adminStr === "運営者"))
          invalidValueErr.push(getErrorDataItem('admin'));
        if (rowData.deleteFlgStr.length === 0)
          requiredFieldErr.push(getErrorDataItem('deleteFlg'));
        if ((rowData.deleteFlgStr.length > 0) && !(rowData.deleteFlgStr === "利用可" || rowData.deleteFlgStr === "利用不可" || rowData.deleteFlgStr === "利用停止"))
          invalidValueErr.push(getErrorDataItem('deleteFlg'));
      }
      // 性別
      if ((rowData.sexStr.length > 0) && !(rowData.sexStr === "男" || rowData.sexStr === "女" || rowData.sexStr === "その他" || rowData.sexStr === "　")) {
        invalidValueErr.push(getErrorDataItem('sex'));
      }
      // 未登録値チェック

      //検索キー
      if (searchKeyList?.length !== 0) {
        // 検索キーのコレクション(searchKeys)が存在する場合
        let userSearchKey1Doc = searchKeyList?.filter((item) => item.name === 'userSearchKey1');
        let userSearchKey2Doc = searchKeyList?.filter((item) => item.name === 'userSearchKey2');
        let userSearchKey3Doc = searchKeyList?.filter((item) => item.name === 'userSearchKey3');
        if (userSearchKey1Doc === undefined || userSearchKey1Doc?.length === 0) {
          // 検索キー1マスタが存在しない場合
          // 取り込んだExcelの検索キー1が入力されていない → チェックしない
          // 取り込んだExcelの検索キー1が入力されている → エラーとする
          if (rowData.searchKey1) {
            unregisteredValueErr.push(getErrorDataItem('searchKey1'));
          }
        } else {
          // 検索キー1マスタが存在する場合
          // 取り込んだExcelの検索キー1がマスタに存在するかチェック
          let userSearchKey1 = searchKeyList?.filter((item) => item.name === 'userSearchKey1')[0]['keyValues'];
          let searchKey1Item = userSearchKey1?.filter((item) => item.searchName === rowData.searchKey1)[0];
          if (rowData.searchKey1 && (searchKey1Item === undefined || searchKey1Item === null)) {
            // 検索キー1がマスタに存在しない場合
            unregisteredValueErr.push(getErrorDataItem('searchKey1'));
          }
        }
        if (userSearchKey2Doc === undefined || userSearchKey2Doc?.length === 0) {
          // 検索キー2マスタが存在しない場合
          // 取り込んだExcelの検索キー2が入力されていない → チェックしない
          // 取り込んだExcelの検索キー2が入力されている → エラーとする
          if (rowData.searchKey2) {
            unregisteredValueErr.push(getErrorDataItem('searchKey2'));
          }
        } else {
          // 検索キー2マスタが存在する場合
          // 取り込んだExcelの検索キー2がマスタに存在するかチェック
          let userSearchKey2 = searchKeyList?.filter((item) => item.name === 'userSearchKey2')[0]['keyValues'];
          let searchKey2Item = userSearchKey2?.filter((item) => item.searchName === rowData.searchKey2)[0];
          if (rowData.searchKey2 && (searchKey2Item === undefined || searchKey2Item === null)) {
            // 検索キー2が存在しない場合
            unregisteredValueErr.push(getErrorDataItem('searchKey2'));
          }
        }
        if (userSearchKey3Doc === undefined || userSearchKey3Doc?.length === 0) {
          // 検索キー3マスタが存在しない場合
          // 取り込んだExcelの検索キー3が入力されていない → チェックしない
          // 取り込んだExcelの検索キー3が入力されている → エラーとする
          if (rowData.searchKey3) {
            unregisteredValueErr.push(getErrorDataItem('searchKey3'));
          }
        } else {
          // 検索キー3マスタが存在する場合
          // 取り込んだExcelの検索キー3がマスタに存在するかチェック
          let userSearchKey3 = searchKeyList?.filter((item) => item.name === 'userSearchKey3')[0]['keyValues'];
          let searchKey3Item = userSearchKey3?.filter((item) => item.searchName === rowData.searchKey3)[0];
          if (rowData.searchKey3 && (searchKey3Item === undefined || searchKey3Item === null)) {
            // 検索キー3が存在しない場合
            unregisteredValueErr.push(getErrorDataItem('searchKey3'));
          }
        }
      } else {
        // 検索キーのコレクション(searchKeys)が存在しない場合
        // 取り込んだExcelの検索キー1,2,3の値がそれぞれ入力されていた場合エラーとする
        if (rowData.searchKey1) {
          unregisteredValueErr.push(getErrorDataItem('searchKey1'));
        }
        if (rowData.searchKey2) {
          unregisteredValueErr.push(getErrorDataItem('searchKey2'));
        }
        if (rowData.searchKey3) {
          unregisteredValueErr.push(getErrorDataItem('searchKey3'));
        }
      }
      // フォーマットチェック
      if (!(rowData.lastNameKana === "" || regexKanaAlpNum.test(rowData.lastNameKana)))
        invalidFormatErr.push(getErrorDataItem('lastNameKana'));
      if (!(rowData.birthDateVal === '' || rowData.birthDateVal === null) && Number.isNaN(new Date(rowData.birthDateVal).getTime()))
        invalidFormatErr.push(getErrorDataItem('birthDate'));
      const familyEmailRegex = /^.+@.+\..+/;
      if (!(rowData.familyEmail1 === "" || familyEmailRegex.test(rowData.familyEmail1)))
        invalidFormatEmailsCol.push(getColumnIndex('familyEmail'));
      if (!(rowData.familyEmail2 === "" || familyEmailRegex.test(rowData.familyEmail2)))
        invalidFormatEmailsCol.push(getColumnIndex('familyEmail2'));
      if (!(rowData.familyEmail3 === "" || familyEmailRegex.test(rowData.familyEmail3)))
        invalidFormatEmailsCol.push(getColumnIndex('familyEmail3'));
      if (!(rowData.familyEmail4 === "" || familyEmailRegex.test(rowData.familyEmail4)))
        invalidFormatEmailsCol.push(getColumnIndex('familyEmail4'));
      if (!(rowData.familyEmail5 === "" || familyEmailRegex.test(rowData.familyEmail5)))
        invalidFormatEmailsCol.push(getColumnIndex('familyEmail5'));
      if (invalidFormatEmailsCol.length > 0) {
        invalidFormatErr.push({colNo: invalidFormatEmailsCol, colName: "イベント参加履歴メール"});
      }
      const zipCodeRegex = /^\d{3}-\d{4}$/;
      if (!(rowData.zipCode === "" || zipCodeRegex.test(rowData.zipCode)))
        invalidFormatErr.push(getErrorDataItem('zipCode'));
    }

    if (accountSuspensionErr.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_DATA_DIFF, accountSuspensionErr));
    }
    if (accountSuspensionSettingErr.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_CAN_NOT_SETTING_ACCOUNT_SUSPENSION, accountSuspensionSettingErr));
    }
    if (requiredFieldErr.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_REQUIRED_FIELD, requiredFieldErr));
    }
    if (invalidValueErr.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_INVALID_VALUE, invalidValueErr));
    }
    if (unregisteredValueErr.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_UNREGISTERED_VALUE, unregisteredValueErr));
    }
    if (invalidFormatErr.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_INVALID_FORMAT, invalidFormatErr));
    }

    // グループ
    const overLimitGroupNames: string[] = [];
    const notFoundGroupNames: string[] = [];
    const errorGroupCols: number[] = [];

    rowData.groupNameList?.forEach((group: { name: string; col: number }) => {
      const groupItem = groupList?.find((item) => item.name === group.name);
      if (!groupItem) {
        // グループが存在しない場合
        notFoundGroupNames.push(group.name);
        errorGroupCols.push(group.col);
      } else {
        const currentCount = groupUserCountMap[groupItem.id] ?? 0;
        const alreadyRegistered = alreadyRegisteredGroupMap[groupItem.id]?.has(company.displayId + targetId);
        if (currentCount >= 1000 && !alreadyRegistered) {
          // グループの人数上限超過
          overLimitGroupNames.push(group.name);
          errorGroupCols.push(group.col);
        }
      }
    });

    if (notFoundGroupNames.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_UNREGISTERED_VALUE + `：${notFoundGroupNames.join("、")}`, [{
        colNo: [...new Set(errorGroupCols)],
        colName: "所属グループ",
        message: `[所属グループ]` + ConstMessage.IMPORT_ERR_UNREGISTERED_VALUE + `：${notFoundGroupNames.join("、")}`
      }]));
    }
    if (overLimitGroupNames.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_OVERLIMITGROUP_VALUE + `：${overLimitGroupNames.join("、")}`, [{
        colNo: [...new Set(errorGroupCols)],
        colName: "所属グループ",
        message: `[所属グループ]` + ConstMessage.IMPORT_ERR_OVERLIMITGROUP_VALUE + `：${overLimitGroupNames.join("、")}`
      }]));
    }
    return targetRowError;
  };

  /**
   * 処理行のデータを返す（利用者情報）
   */
  const getRowData = (row: ExcelJS.Row, endCol: number) => {
    const lastName = row.getCell("lastName").value?.toString() ?? '';
    const lastNameKana = row.getCell("lastNameKana").value?.toString() ?? '';
    const birthDateVal = row.getCell("birthDate").value;
    let birthday = undefined;
    if(typeof(birthDateVal) === 'number'){
      const sn = birthDateVal as number;
      const coefficient = 24 * 60 * 60 * 1000; //日数とミリ秒を変換する係数
      const datesOffset = 70 * 365 + 17 + 1 + 1; //「1900/1/0」～「1970/1/1」 (日数)
      const millisecondsDifference = 9 * 60 * 60 * 1000; //UTCとJSTの時差 (ミリ秒)
      birthday = new Date((sn - datesOffset) * coefficient - millisecondsDifference);
    } else if(birthDateVal?.toString() !== undefined && birthDateVal?.toString() !== ''){
      const date = birthDateVal?.toString()!.replace(/(.+)年(.+)月(.+)日/g,'$1-$2-$3');
      birthday = date === undefined ? undefined : new Date(date);
    }
    const sexStr = row.getCell("sex").value?.toString() ?? '';
    const sex = sexStr === '男' ? 0 : sexStr === '女' ? 1 : sexStr === 'その他' ? 2 : undefined;
    const phoneNumber = row.getCell("phoneNumber").value?.toString() ?? '';
    const faxNumber = row.getCell("faxNumber").value?.toString() ?? '';
    let familyEmail1 = row.getCell("familyEmail").value?.toString() ?? '';
    if (typeof row.getCell("familyEmail").value === 'object') familyEmail1 = row.getCell("familyEmail").text;
    let familyEmail2 = row.getCell("familyEmail2").value?.toString() ?? '';
    if (typeof row.getCell("familyEmail2").value === 'object') familyEmail2 = row.getCell("familyEmail2").text;
    let familyEmail3 = row.getCell("familyEmail3").value?.toString() ?? '';
    if (typeof row.getCell("familyEmail3").value === 'object') familyEmail3 = row.getCell("familyEmail3").text;
    let familyEmail4 = row.getCell("familyEmail4").value?.toString() ?? '';
    if (typeof row.getCell("familyEmail4").value === 'object') familyEmail4 = row.getCell("familyEmail4").text;
    let familyEmail5 = row.getCell("familyEmail5").value?.toString() ?? '';
    if (typeof row.getCell("familyEmail5").value === 'object') familyEmail5 = row.getCell("familyEmail5").text;
    const familyEmail = familyEmail1 + ',' + familyEmail2 + ',' + familyEmail3 + ',' + familyEmail4 + ',' + familyEmail5;
    const adminStr = row.getCell("admin").value?.toString() ?? '';
    const admin = adminStr === "運営者";
    const deleteFlgStr = row.getCell("deleteFlg").value?.toString() ?? '';
    const deleteFlg = deleteFlgStr === "利用不可" ? true : false;
    const accountSuspensionFlg = deleteFlgStr === "利用停止" ? true : false;
    const zipCode = row.getCell("zipCode").value?.toString() ?? '';
    const address = row.getCell("address").value?.toString() ?? '';
    const searchKey1 = row.getCell("searchKey1").value?.toString() ?? '';
    const searchKey2 = row.getCell("searchKey2").value?.toString() ?? '';
    const searchKey3 = row.getCell("searchKey3").value?.toString() ?? '';
    const note = row.getCell("note").value?.toString();
    const groupNameList = [];
    for(let j = 23; j < endCol; j++) {
      const targetColGroup = row.getCell(j).value?.toString() ?? "";
      if (targetColGroup !== "") {
        groupNameList.push({col: j, name: targetColGroup});
      }
    }

    return {
      lastName: lastName,
      lastNameKana: lastNameKana,
      birthDateVal: birthDateVal,
      birthday: birthday,
      sexStr: sexStr,
      sex: sex,
      phoneNumber: phoneNumber,
      faxNumber: faxNumber,
      familyEmail1: familyEmail1,
      familyEmail2: familyEmail2,
      familyEmail3: familyEmail3,
      familyEmail4: familyEmail4,
      familyEmail5: familyEmail5,
      familyEmail: familyEmail,
      adminStr: adminStr,
      admin: admin,
      deleteFlgStr: deleteFlgStr,
      deleteFlg: deleteFlg,
      accountSuspensionFlg: accountSuspensionFlg,
      zipCode: zipCode,
      address: address,
      searchKey1: searchKey1,
      searchKey2: searchKey2,
      searchKey3: searchKey3,
      note: note,
      groupNameList: groupNameList
    };
  }

  // 汎用ダイアログ用
  // toggleDialog
  // initDialog
  const toggleDialog = () => {
    setIsOpenDialog(isOpenDialog);
  };
  const initDialog = () => {
    setDialogTitle("");
    setDialogChildren("");
    setDialogActions([]);
  };

  /** カラムの存在チェック */
  const getTargetCol = (targetCol: ExcelJS.Row, targetColName: String) => {
    for (let i = 1; i <= targetCol.cellCount; i++){
      const targetColValue = targetCol.getCell(i).value?.toString() ?? '';
      if(targetColName === targetColValue){
        return i;
      }
    };
    return -1;
  }

  // エラーデータを返す（利用者情報）
  const getErrorDataItem = (name: string) => {
    return {colNo: [getColumnIndex(name)], colName: getColumnHeader(name)};
  }

  // インデックスを返す（利用者情報）
  const getColumnIndex = (name: string) => {
    return column.findIndex((target) => target.key === name) + 1;
  }

  // カラム名を返す（利用者情報）
  const getColumnHeader = (name: string) => {
    return column.find((target) => target.key === name)?.header;
  }

  // プログレスバー
  const setProgress = (progress: number) => {
    setLoadProgress(progress);
    setProgressSubText(ConstMessage.PROGRESS_SUB_TEXT);
  }

  // エラーデータセット
  const getErrorData = (errMessage: string, errArr: any[]) => {
    return {
        message: errMessage,
        data: errArr
      };
  }

  /** 利用者情報　エラーファイルのダウンロード */
  const downloadErrorFile = async () => {
    if (!targetFile) return;
    console.time("エラーファイル出力"); 
    const fileURL = window.URL.createObjectURL(targetFile as Blob);
    try {
      const response = await fetch(fileURL);
      const arrayBuffer = await response.arrayBuffer();
      const data = new Uint8Array(arrayBuffer);
      const workbook = new ExcelJS.Workbook();
      if(loadType === 'xlsx'){
        // Excel
        await workbook.xlsx.load(data as any);
      } else {
        // CSV
        await workbook.csv.readFile(data as any);
      }
      const worksheet = workbook.worksheets[0];
      worksheet.pageSetup = {orientation:'portrait'};
      const columnRowNum = annotation.length + 2;
      const columnHeader = worksheet.getRow(columnRowNum);
      const endCol = getTargetCol(columnHeader, '最終列');
          
      if (getTargetCol(columnHeader, '取込結果') < 0) {
        worksheet.getRow(columnRowNum).getCell(endCol + 1).value = '取込結果';
        worksheet.getRow(columnRowNum).getCell(endCol + 2).value = 'エラー内容';
      }
      const resultCol = endCol + 1;
      const errorInfoCol = endCol + 2;

      const defaultStyle = worksheet.getCell('J1').style;

      const alignmentStyle: Partial<ExcelJS.Alignment>  = {
        horizontal: "center",
        vertical: "middle"
      }
      const startRow = columnRowNum + 2;
      const totalRows = worksheet.rowCount - startRow + 1;

      setProgress(5);
      await new Promise(resolve => setTimeout(resolve, 50));

      for (let i = startRow; i < worksheet.rowCount + 1; i++) {
        const row = worksheet.getRow(i);
        const id = row.getCell(2).value?.toString();
        if (!id) continue;

        const targetDataInfo = fileDataInfo.find(d => d.id === id);
        if (!targetDataInfo) continue;

        // インポート対象データの場合
        if (targetDataInfo.status === "success") {
          // 登録成功データ
          for (let j = 3; j < endCol; j++) {
            row.getCell(j).style.fill = undefined;
          }
          row.getCell(resultCol).value = "○";
          row.getCell(errorInfoCol).value = "";
        } else if (targetDataInfo.status === "failed") {
          // 登録失敗データ
          for (let j = 3; j < endCol; j++) {
            const cellStyle = row.getCell(j).style;
            row.getCell(j).style = { ...defaultStyle };
            row.getCell(j).style.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            }
            row.getCell(j).protection = { locked: false }; 
            if(
              j === COL_NUM_BIRTHDAY || 
              j === COL_NUM_SEX || 
              j === COL_NUM_TEL || 
              j === COL_NUM_FAX || 
              j === COL_NUM_ADMIN || 
              j === COL_NUM_ACCOUNT || 
              j === COL_NUM_ZIP || 
              j === COL_NUM_SEARCH_KEY_1 || 
              j === COL_NUM_SEARCH_KEY_2 || 
              j === COL_NUM_SEARCH_KEY_3 
            ){
              // 中央ぞろえに設定
              row.getCell(j).style.alignment = alignmentStyle as ExcelJS.Alignment;

              // 日付の設定
              if(j === COL_NUM_BIRTHDAY){
                row.getCell(j).style.numFmt = cellStyle.numFmt;
              }
            }
          }
          const infoStr: string[] = [];
          targetDataInfo.info.forEach((items: any) => {
            let colNameStr = ""
            items.data.forEach((item: any) => {
              colNameStr += `[${item.colName}]`;
              item.colNo.forEach((col: any) => {
                row.getCell(col).style.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb :'FFFFCCFF' },
                }

              });
            });
            infoStr.push(colNameStr + items.message);
          });
          row.getCell(resultCol).value = "×";
          row.getCell(errorInfoCol).value = infoStr.join('／');
        } else if (targetDataInfo.status === "error") {
          // 処理中にエラーが発生したデータ
          const infoStr: string[] = [];
          row.getCell(resultCol).value = "×";
          row.getCell(errorInfoCol).value = infoStr.join('／');
        }
        worksheet.getCell('C1').protection = { locked: true }; 

        if ((i - startRow) % 90 === 0 || i === worksheet.rowCount) {
          const progress = 5 + Math.floor(((i - startRow + 1) / totalRows) * 90);
          setProgress(progress);
          await new Promise(resolve => setTimeout(resolve, 0));
        }
      }

      // ダウンロードリンク
      const a = document.createElement("a");
      // BOM
      const bom = "\uFEFF";
      const uint8Array = loadType === "xlsx"
        ? await workbook.xlsx.writeBuffer()
        : bom + await workbook.csv.writeBuffer();
      const blob = new Blob([uint8Array], { type: "application/octet-binary" });
      a.href = window.URL.createObjectURL(blob);

      // エラーファイルの先頭に付与する文字列を取得
      const fileNamePrefix = getImportErrorFileNamePrefix(targetFile.name);
      a.download = `${fileNamePrefix}利用者情報_${company.name}_${convertDateToStringCompactFormat(new Date())}.${loadType}`;
      a.click();
      a.remove();
      setProgress(100);
      console.timeEnd("エラーファイル出力"); 
    } catch (e: any) {
      console.error(e);
      dispatch(alertOpen(AlertValue(e.toString(), "danger")));
    }
  };

  const optionColumn = [
    { header: "No.", key: "no" },
    { header: "利用者番号", key: "id" },
    { header: "*氏名", key: "lastName" },
    { header: "*役割", key: "admin"},
    { header: "ポイント管理", key: "pointAssignmentAuthority"},
    { header: "予備１", key: "extra1"},
    { header: "予備２", key: "extra2"},
    { header: "予備３", key: "extra3"},
    { header: "予備４", key: "extra4"},
  ];

  const onOptionImportAll = async (
    format: 'csv' | 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsLoadModal(true);
    setExcelImportType("option");
    const fileNameList: string[] = [];
    if(file){
      fileNameList.push(file.name);
    }

    // インポート前確認ボタンアクション
    const getBtnActions = (res: string) => {
      if (res) {
        // エラーがある場合：OKのみ（閉じるのみ）
        const actions: BtnProps[] = [
          {
            color: "indigo",
            children: "OK",
            onClick: () => {
              e.target.value = '';
              setIsOpenDialog(false);
              initDialog();
            }
          },
        ];
        return actions;

      } else {
        // エラーがない場合：OK or キャンセル
        const actions: BtnProps[] = [
          {
            color: "indigo",
            outline: true,
            children: "キャンセル",
            className:"w-[132px]",
            onClick: () => {
              e.target.value = '';
              setIsOpenDialog(false);
              initDialog();
            }
          },
          {
            color: "indigo",
            children: "OK",
            className:"w-[132px]",
            onClick: () => {
              optionImportAll(format, file, e);
              setIsOpenDialog(false);
              initDialog();
            }
          },
        ];
        return actions;
      }
    };

    // インポート前確認ダイアログ
    checkOptionImportAll(format, file, e).then((res) => {
      const importErrorMessage = (
        <div className={'text-red-500'}>
          {res}
        </div>);

      const dialogChildren = (<>
        {res !== null ? "ファイルチェックが完了しました。" : "ファイルチェックが完了しました。以下のExcelファイルの内容を登録しますか？"}
        <ul className={`list-disc m-2 text-${format === 'xlsx' ? 'green' : 'yellow' }-700`}>
          {
            fileNameList.map((name, index) =>
              (<li className={"flex"} key={`fileList-${index}`}><DocumentArrowUpIcon className={"h-6 w-6"}/>{name}</li>))
          }
        </ul>
        {res !== null ? "" : importWorningMessage}
        {res !== null ? "" : importAllWorningMessage}
        {res !== null ? importErrorMessage : ""}
      </>)

      setIsOpenDialog(true);
      setDialogTitle("Excel一括取込確認");
      setDialogChildren(dialogChildren);
      setDialogActions(getBtnActions(res));
    });
  };

   /** 利用者オプション設定　インポート前ファイルチェック */
   const checkOptionImportAll = async (
    format: 'csv' | 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const blobURL = window.URL.createObjectURL(file as Blob);
    const promise = new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      setLoadType(format);
      xhr.onload = async () => {
        const result = xhr.response;
        const data = new Uint8Array(result);
        try{
          const workbook = new ExcelJS.Workbook();
          if(format === 'xlsx'){
            // Excel
            await workbook.xlsx.load(data as any);
          } else {
            // CSV
            await workbook.csv.readFile(result);
          }
          const worksheet = workbook.worksheets[0];
          worksheet.pageSetup = {orientation:'portrait'};
          // ファイル内の団体番号と実行者の団体番号を比較
          const tenantNo = company.displayId;
          const tenantNoRow = worksheet.getRow(1);
          if(tenantNo !== (tenantNoRow.getCell(3).value?.toString() ?? '')){
            throw new Error(ConstMessage.ERR_DIFFERENT_TENANT_ID);
          }
          // n行目から項目リストを取得して正しいファイルか確認
          const columnRowNum = annotation.length + 2;
          const columnHeader = worksheet.getRow(columnRowNum);
          const listHeader = optionColumn.map((item) => item.header);
          for (let i = 0; i < optionColumn.length; i++){
            if(listHeader[i] !== (columnHeader.getCell(i + 1).value?.toString() ?? '')){
              throw new Error(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
            }
          };
   
          setIsLoadModal(false);
          resolve(null);
        } catch (e: any) {
          console.error(e);
          setIsLoadModal(false);
          resolve(e.message);
        }
      };

      xhr.responseType = "arraybuffer";
      xhr.open("GET", blobURL);
      xhr.send(null);
    });

    return promise;
  };

  /** 利用者オプション設定　一括入力 */
  const optionImportAll = async (
    format: 'csv' | 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoadType(format);
    optionImportData(format, file).then(async (res) => {
      setFileDataInfo(res.data);
      e.target.value = '';
    });
  };

  /** 利用者オプション設定　一括入力処理 */
  const optionImportData = async (
    format: 'csv' | 'xlsx',
    file: File | null
  ) => {
    const groupUserCountMap: Record<string, number> = {};
    const alreadyRegisteredGroupMap: Record<string, Set<string>> = {};
    const userMap: Record<string, UserData> = {};
    const allUsers: any[] = [];
    let page = 1;
    let hasMore = true;
    const pageSize = 5000;
    let totalCount = 0;

    console.time("利用者オプションExcel取込");
    setIsImport(true);
    setLoadProgress(0);
    setProgressSubText(ConstMessage.PROGRESS_SUB_TEXT);
    setLoadType(format);

    while (hasMore) {
      const result = await requestGetUser(page, pageSize, { tenantId: tenantId! });
      if (!result.success) {
        console.error("ユーザー取得に失敗", result.error);
        break;
      }
      if (page === 1) totalCount = result.totalCount ?? 0;
      allUsers.push(...result.users);
      hasMore = result.users.length === pageSize;

      const progressUserFetch = Math.round((allUsers.length / totalCount) * 0.2 * 100);
      setLoadProgress(progressUserFetch);
      page++;
      await new Promise(resolve => setTimeout(resolve, 0));
    }

    // Map 初期化
    allUsers.forEach(user => {
      userMap[company.displayId + user.displayId] = user;
      (user.groups || []).forEach((g: { id: string | number }) => {
        if (!alreadyRegisteredGroupMap[g.id]) alreadyRegisteredGroupMap[g.id] = new Set();
        alreadyRegisteredGroupMap[g.id].add(user.id);
        groupUserCountMap[g.id] = (groupUserCountMap[g.id] || 0) + 1;
      });
    });

    const blobURL = window.URL.createObjectURL(file as Blob);

    return new Promise<any>((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.responseType = "arraybuffer";
      xhr.open("GET", blobURL);
      xhr.send(null);

      xhr.onload = async () => {
        try {
          const data = new Uint8Array(xhr.response);
          const workbook = new ExcelJS.Workbook();
          if (format === 'xlsx') {
            // Excel
            await workbook.xlsx.load(data as any);
          } else {
            // CSV
            await workbook.csv.readFile(xhr.response);
          }
          const worksheet = workbook.worksheets[0];
          worksheet.columns = optionColumn;
          worksheet.pageSetup = {orientation:'portrait'};
          const columnRowNum = annotation.length + 2;
          const columnHeader = worksheet.getRow(columnRowNum);
          const resultCol = getTargetCol(columnHeader, '取込結果');

          const recordResult: { id: string; status: string; info?: any }[] = [];
          const fileDataInfo: { id: string; status: string; info?: any }[] = [];
          const bulkUpdateList: User[] = [];

          const startRow = columnRowNum + 2;
          const targetRowCnt = resultCol >= 0
            ? worksheet.rowCount + 1 - startRow - worksheet.getColumn(resultCol).values.filter((v) => v === "○").length
            : worksheet.rowCount + 1 - startRow;
          let processRowCnt = 0;

          for (let i = startRow; i < worksheet.rowCount + 1; i++) {
            const row = worksheet.getRow(i);
            // 取込結果
            if (resultCol >= 0) {
              const resultVal = row.getCell(resultCol).value?.toString() ?? "";
              if (resultVal === "○") continue;
            }

            const idVal = row.getCell("id").value;
            if (!idVal) continue;
            const id = idVal.toString();
            const rowData = getOptionRowData(row);

            const targetRowError = rowData.lastName !== ''
              ? await targetOptionRowDataCheck(rowData, id, userMap)
              : [];

            if (!rowData.lastName) {
              const emptyRecord = { id, status: '' };
              recordResult.push(emptyRecord);
              fileDataInfo.push(emptyRecord);
              continue;
            }

            if (targetRowError.length > 0) {
              const failedRecord = { id, status: 'failed', info: targetRowError };
              recordResult.push(failedRecord);
              fileDataInfo.push(failedRecord);
              continue;
            }

            // 更新用データ作成
            const updateData: any = {
              id: `${company.displayId}${id}`,
              admin: rowData.admin,
              pointAssignmentAuthority: rowData.pointAssignmentAuthority,
            };
            bulkUpdateList.push(updateData);
            const successRecord = { id, status: 'success' };
            recordResult.push(successRecord);
            fileDataInfo.push(successRecord);

            processRowCnt++;
            const progressRow = 0.2 + (processRowCnt / targetRowCnt) * 0.1; // 20~30%
            setLoadProgress(Math.round(progressRow * 100));
            await new Promise(resolve => setTimeout(resolve, 0));
          }

          const batchSize = 1000;
          if (bulkUpdateList.length > 0) {
            const batches = [];
            for (let i = 0; i < bulkUpdateList.length; i += batchSize) {
              batches.push(bulkUpdateList.slice(i, i + batchSize));
            }

            for (let i = 0; i < batches.length; i++) {
              const batch = batches[i];

              // userMap はこのバッチに含まれるユーザーだけに最小化
              const userMapBatch = batch.reduce<Record<string, UserData>>((map, user) => {
                const original = allUsers.find(u => u.id === user.id);
                if (original) map[user.id] = { ...original, groups: original.groups ?? [] };
                return map;
              }, {});

              try {
                const result = await updatepointAssignmentAuthorityData(tenantId!, batch, company.displayId, userMapBatch);
                if (!result.success) {
                  console.error("Batch failed:", result);
                  break;
                }
              } catch (err) {
                console.error(`Batch error at index ${i}`, err);
                break;
              }

              const progressBatch = 0.3 + ((i + 1) / batches.length) * 0.65; // 30~95%
              setLoadProgress(Math.round(progressBatch * 100));
              await new Promise(resolve => setTimeout(resolve, 0));
            }
          }

          setLoadProgress(100);
          setFileDataInfo(fileDataInfo);
          const hasFailed = recordResult.some(r => r.status !== "success");
          console.timeEnd("利用者オプションExcel取込");
          resolve({ status: hasFailed ? "failed" : "success", data: recordResult, fileDataInfo });

        } catch (e: any) {
          console.error(e);
          dispatch(alertOpen(AlertValue(e.toString(), "danger")));
          setLoadProgress(-1);
          resolve({status: "error", data: e})
        }
      };
    });
  };

  /**
   * 利用者オプション設定Excel 処理行のデータを返す
   */
  const getOptionRowData = (row: ExcelJS.Row) => {
    const lastName = row.getCell("lastName").value?.toString() ?? '';
    const adminStr = row.getCell("admin").value?.toString() ?? '';
    const admin = adminStr === "運営者";
    const pointAssignmentAuthorityStr = row.getCell("pointAssignmentAuthority").value?.toString() ?? '';
    const pointAssignmentAuthority = pointAssignmentAuthorityStr === "利用可" ? true : pointAssignmentAuthorityStr === "利用不可" ? false : undefined;

    return {
      lastName: lastName,
      adminStr: adminStr,
      admin: admin,
      pointAssignmentAuthorityStr: pointAssignmentAuthorityStr,
      pointAssignmentAuthority: pointAssignmentAuthority,
    };
  }

  /**
   * 利用者オプション設定Excel取込 バリデーション
   */
  const targetOptionRowDataCheck = async (
    rowData: any, 
    targetId: string,
    userMap: { [userId: string]: UserData },
  ) => {
    const targetUser = userMap[company.displayId + targetId];
    if (targetUser !== undefined) {
      const targetRowError = [];
      const requiredFieldErr = [];
      const invalidValueErr = [];
      const registrationInformationErr = [];

      // 無効値チェック
      if (rowData.adminStr.length === 0 || rowData.adminStr === "　")
        requiredFieldErr.push(getOptionErrorDataItem('admin'));
      if ((rowData.adminStr.length > 0) && !(rowData.adminStr === "利用者" || rowData.adminStr === "運営者" || rowData.adminStr === "　"))
        invalidValueErr.push(getOptionErrorDataItem('admin'));
      if ((rowData.adminStr === "運営者") && (rowData.pointAssignmentAuthorityStr.length === 0 || rowData.pointAssignmentAuthorityStr === "　"))
        requiredFieldErr.push(getOptionErrorDataItem('pointAssignmentAuthority'));
      if ((rowData.pointAssignmentAuthorityStr.length > 0) && !(rowData.pointAssignmentAuthorityStr === "利用可" || rowData.pointAssignmentAuthorityStr === "利用不可" || rowData.pointAssignmentAuthorityStr === "　"))
        invalidValueErr.push(getOptionErrorDataItem('pointAssignmentAuthority'));
      if ((rowData.adminStr === "利用者") && (rowData.pointAssignmentAuthorityStr === "利用可"))
        registrationInformationErr.push(getOptionErrorDataItem('pointAssignmentAuthority'));

      if (requiredFieldErr.length > 0) {
        targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_REQUIRED_FIELD, requiredFieldErr));
      }
      if (invalidValueErr.length > 0) {
        targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_INVALID_VALUE, invalidValueErr));
      }
      if (registrationInformationErr.length > 0) {
        targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_REGISTRATION_INFORMATION, registrationInformationErr));
      }
      return targetRowError;
    } else {
      const notFoundErr = [];
      notFoundErr.push(getOptionErrorDataItem('id'));
      return [getErrorData(ConstMessage.IMPORT_ERR_NOT_FOUND_USER, notFoundErr)];
    }
  };

  /** 利用者オプション設定　エラーファイルのダウンロード */
  const downloadOptionErrorFile = async () => {
    if (!targetFile) return;
    console.time("利用者オプション設定エラーファイル出力");

    try {
      const fileURL = window.URL.createObjectURL(targetFile as Blob);
      const response = await fetch(fileURL);
      const arrayBuffer = await response.arrayBuffer();
      const data = new Uint8Array(arrayBuffer);
      const workbook = new ExcelJS.Workbook();

      if (loadType === 'xlsx') {
        // Excel
        await workbook.xlsx.load(data as any);
      } else {
        // CSV
        await workbook.csv.readFile(data as any);
      }
      const worksheet = workbook.worksheets[0];
      worksheet.pageSetup = {orientation:'portrait'};
      const columnRowNum = annotation.length + 2;
      const columnHeader = worksheet.getRow(columnRowNum);
      const endCol = getTargetCol(columnHeader, '予備４');
          
      if (getTargetCol(columnHeader, '取込結果') < 0) {
        worksheet.getRow(columnRowNum).getCell(endCol + 1).value = '取込結果';
        worksheet.getRow(columnRowNum).getCell(endCol + 2).value = 'エラー内容';
      }
      const resultCol = endCol + 1;
      const errorInfoCol = endCol + 2;
      const defaultStyle = worksheet.getCell('D1').style;

      const alignmentStyle: Partial<ExcelJS.Alignment> = {
        horizontal: "center",
        vertical: "middle"
      };

      const startRow = columnRowNum + 2;
      const totalRows = worksheet.rowCount - startRow + 1;

      setProgress(5);
      await new Promise(resolve => setTimeout(resolve, 50));

      for (let i = startRow; i < worksheet.rowCount + 1; i++) {
        const row = worksheet.getRow(i);
        const id = row.getCell(2).value?.toString();
        if (!id) continue;

        const targetDataInfo = fileDataInfo.find(d => d.id === id);
        if (!targetDataInfo) continue;
        // インポート対象データの場合
        if (targetDataInfo.status === "success") {
          // 登録成功データ
          for (let j = 4; j < endCol; j++) row.getCell(j).style.fill = undefined;
          row.getCell(resultCol).value = "○";
          row.getCell(errorInfoCol).value = "";
        } else if (targetDataInfo.status === "failed") {
          // 登録失敗データ
          for (let j = 4; j < endCol; j++) {
            const cellStyle = row.getCell(j).style;
            row.getCell(j).style = { ...defaultStyle };
            row.getCell(j).style.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };
            row.getCell(j).protection = { locked: false };
            row.getCell(j).style.alignment = alignmentStyle as ExcelJS.Alignment;
            if (j === COL_NUM_BIRTHDAY) row.getCell(j).style.numFmt = cellStyle.numFmt;
          }
          const infoStr: string[] = [];
          targetDataInfo.info.forEach((items: any) => {
            let colNameStr = "";
            items.data.forEach((item: any) => {
              colNameStr += `[${item.colName}]`;
              item.colNo.forEach((col: any) => {
                row.getCell(col).style.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFFFCCFF' },
                };
              });
            });
            infoStr.push(colNameStr + items.message);
          });
          row.getCell(resultCol).value = "×";
          row.getCell(errorInfoCol).value = infoStr.join('／');
        } else if (targetDataInfo.status === "error") {
          // 処理中にエラーが発生したデータ
          const infoStr: string[] = [];
          row.getCell(resultCol).value = "×";
          row.getCell(errorInfoCol).value = infoStr.join('／');
        }
        worksheet.getCell('D1').protection = { locked: true };
        if ((i - startRow) % 90 === 0 || i === worksheet.rowCount) {
          const progress = 5 + Math.floor(((i - startRow + 1) / totalRows) * 90);
          setProgress(progress);
          await new Promise(resolve => setTimeout(resolve, 0));
        }
      }

      // ダウンロードリンク
      const a = document.createElement("a");
      // BOM
      const bom = "\uFEFF";
      const uint8Array = loadType === "xlsx"
        ? await workbook.xlsx.writeBuffer()
        : bom + await workbook.csv.writeBuffer();
      const blob = new Blob([uint8Array], { type: "application/octet-binary" });
      a.href = window.URL.createObjectURL(blob);

      // エラーファイルの先頭に付与する文字列を取得
      const fileNamePrefix = getImportErrorFileNamePrefix(targetFile.name);
      a.download = `${fileNamePrefix}利用者オプション設定_${company.name}_${convertDateToStringCompactFormat(new Date())}.${loadType}`;
      a.click();
      a.remove();
      setProgress(100);
      console.timeEnd("利用者オプション設定エラーファイル出力");
    } catch (e: any) {
      console.error(e);
      dispatch(alertOpen(AlertValue(e.toString(), "danger")));
    }
  };

  // エラーデータを返す（利用者オプション設定）
  const getOptionErrorDataItem = (name: string) => {
    return {colNo: [getOptionColumnIndex(name)], colName: getOptionColumnHeader(name)};
  }

  // インデックスを返す（利用者オプション設定）
  const getOptionColumnIndex = (name: string) => {
    return optionColumn.findIndex((target) => target.key === name) + 1;
  }

  // カラム名を返す（利用者オプション設定）
  const getOptionColumnHeader = (name: string) => {
    return optionColumn.find((target) => target.key === name)?.header;
  }

  const loginInfoCol: GridCol[] = [
    {
      field: "no",
      headerName: "No",
      style: ""
    },
    {
      field: "createAt",
      headerName: "受付日時",
      style: ""
    },
    {
      field: "status",
      headerName: "ステータス",
      style: ""
    },
    {
      field: "completionAt",
      headerName: "出力日時",
      style: ""
    },
    {
      field: "fileName",
      headerName: "ファイル名",
      style: "white-space: pre-line w-6/12"
    },
  ]

  const loginInfoRow: GridRow[] = loginPdfCreateStateList.map<GridRow>((item, i) => {
    let displayStatus = "";
    let exportButton = (<></>);
    let shouldShowExportButton = false;
    switch (item.status) {
      case 'inOparation':
        displayStatus = '出力中';
        break;
      case 'completion':
        displayStatus = '出力完了';
        shouldShowExportButton = true;
        break;
      case 'error':
        displayStatus = 'エラー';
        break;
    }
    const createAtData = item.createAt as any;
    const completionAt = item.completionAt !== undefined ? item.completionAt as any : null;

    return {
      rowData: {
        no: (
          <div style={{textAlign: 'right', marginRight: '10px'}}>
            {i + 1}
          </div>
        ),
        fileName: (
          <div style={{ whiteSpace: "pre-line" }}>
            {item.listFlg? (
              // 性能改善後に出力した場合
              <div 
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px' }}
                className="my-1"
              >
                <span>{item.zipFileName}</span>
                {shouldShowExportButton ? (
                  <Button
                    size={'sm'}
                    children={"ダウンロード"}
                    className={"sm:px-4 whitespace-nowrap w-[116px] ml-6"}
                    onClick={() => onDownloadPDF(item.zipFilePath, item.zipFileName)}
                  />
                ) : item.status === 'error' ? (
                  <Button
                    outline
                    size={'sm'}
                    children={"再出力"}
                    className={"sm:px-4 whitespace-nowrap w-[116px] ml-6"}
                    onClick={() => onCreatePDF('reCreate', item)}
                  />
                ) : null}
              </div>
            ) : (
              (() => {
                const files = item.files || [];
                const targetIndex = Math.floor(files.length / 2);
                return (
                  <>
                    {files.map((file, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: '12px',
                        }}
                        className="my-1"
                      >
                        <span>{file.fileName}</span>

                        {item.status === 'error' && index === targetIndex ? (
                          <Button
                            outline
                            size={'sm'}
                            children={"再出力"}
                            className={"sm:px-4 whitespace-nowrap w-[116px] ml-6"}
                            onClick={() => onCreatePDF('reCreate', item)}
                          />
                        ) : shouldShowExportButton ? (
                          <Button
                            size={'sm'}
                            children={"ダウンロード"}
                            className={"sm:px-4 whitespace-nowrap w-[116px] ml-6"}
                            onClick={() => onDownloadPDF(file.filePath, file.fileName)}
                          />
                        ) : null}
                      </div>
                    ))}
                  </>
                );
              })()
            )}
          </div>
        ),
        status: displayStatus,
        createAt: convertDateTimeToString(new Date(createAtData.seconds * 1000)),
        completionAt: completionAt !== null ? convertDateTimeToString(new Date(completionAt.seconds * 1000)) : ''
      }
    }
  });

  const onCreatePDF =  async (status: 'create' | 'reCreate', loginPdfCreateState?: LoginPdfCreateState) => {
    try{
      // PDFエクスポート前確認ダイアログ
      let lastUserId: string | null = null;
      if (status === 'create') {
        let userId = 0;
        loginPdfCreateStateList.filter((state) => state.status === 'completion')
          .forEach(item => {
            item.files.forEach(file => {
              if (userId === 0) {
                userId = Number(file.lastUserId);
              } else {
                if (Number(file.lastUserId) > userId) {
                  userId = Number(file.lastUserId);
                }
              }
            });
          });
          const { count, lastUserDisplayId } = await userQuery.getActiveUserListSort(company);
          if (count === 0) {
            // 出力可能な利用者がいない場合
            dispatch(alertOpen(AlertValue(ConstMessage.ERR_LOGIN_INFO_PDF_NO_DATA, "danger")));
            return;
          }
          if (userId > 0 && lastUserDisplayId && userId < lastUserDisplayId) {
            lastUserId = zeroPadding(userId + 1, 11);
          } else {
            lastUserId = null;
          }
      } else {
        lastUserId = null;
      }
      const actions: BtnProps[] = [
        {
          color: "indigo",
          outline: true,
          children: "キャンセル",
          className:"w-[132px]",
          onClick: () => {
            setIsOpenDialog(false);
            initDialog();
            setIncreasePDFCreateFlg(false);
          }
        },
        {
          color: "indigo",
          children: "OK",
          className:"w-[132px]",
          onClick: () => {
            setIsOpenDialog(false);
            initDialog();
            onClickPDFDownload(lastUserId, status, loginPdfCreateState);
          }
        },
      ];
      const dialogChildren = (<>
        {`利用者ログイン情報PDFを${status === 'create' ? '一括出力' : '再出力'}します。よろしいですか？`}<br></br>
        {lastUserId ? (
          <div className={'mt-3'}>
            <label style={{display: "flex", alignItems: "center", lineHeight: 1.5}}>
              <input
                id={'increase-pdf-create'}
                name={'increase-pdf-create'}
                data-id={'increase-pdf-create'}
                type="checkbox"
                className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 ml-3 mr-2"
                style={{alignSelf: "center"}}
                onChange={increasePDFCreateFlgChange}
              />
              <span>
                {`前回作成から増加した利用者ID分のみ（利用者ID「${lastUserId}」以降）の`}<br></br>
                {`利用者ログイン情報PDFを出力する`}
              </span>
            </label>
          </div>
        ) : (<></>)}
        {exportPDFWarningMessage}
      </>)
      setIsOpenDialog(true);
      setDialogTitle(`PDF${status === 'create' ? '出力' : '再出力'}確認`);
      setDialogChildren(dialogChildren);
      setDialogActions(actions);
    }catch(err){
      console.error(err);
      dispatch(alertOpen(AlertValue(ConstMessage.ERR_LOGIN_INFO_PDF_DOWNLOAD, "danger")));
    }
  }

  const exportPDFWarningMessage = (<div className={'text-red-500 mt-3'}>
    <div>※PDF出力は、ID数によって<span className={"font-bold text-red-700"}>作業時間が長時間になる場合があります。</span></div>
    <div>※一度実行すると中止することはできません。</div>
    <div>※PDFの出力が完了次第メールでご連絡します。</div>
  </div>);

  const increasePDFCreateFlgChange = async (event: any) => {
    increasePDFCreateFlgRef.current = event.target.checked;
  }

  const setIncreasePDFCreateFlg = (flg: boolean) => {
    increasePDFCreateFlgRef.current = flg;
  }

  const onClickPDFDownload = (lastUserId: string | null, status: string, loginPdfCreateState?: LoginPdfCreateState) => {
    dispatch(alertOpen(AlertValue(`出力処理を開始しました。完了後メールが送信されますので画面を更新してください。`, "success")));
    if (status === 'create') {
      createPDF(lastUserId);
    } else {
      reCreatePDF(loginPdfCreateState);
    }
  }

  // ログイン情報PDF作成処理
  const createPDF = async (lastUserId: string | null) => {
    const { count } = await userQuery.getActiveUserListSort(company);
    const userListCount = count;
    const firstUserId = increasePDFCreateFlgRef.current && lastUserId
      ? lastUserId
      : "00000000001";

    const FileData : FileData[] = [{
      status: "standBy",
      createCount: userListCount,
      firstUserId: firstUserId,
      lastUserId: "",
    }];
    const LoginPdfCreateState: LoginPdfCreateState = {
      id: "",
      tenantId: tenantId!,
      status: "standBy",
      files: FileData,
      createUserUid: currentUser?.uid!,
      createAt: new Date(),
      listFlg: true,
    };

    await systemParametersQuery.addLoginPdfCreateState(LoginPdfCreateState);
    setIncreasePDFCreateFlg(false);
  };

  // ログイン情報PDF再作成処理
  const reCreatePDF = async (loginPdfCreateState?: LoginPdfCreateState) => {
    if (loginPdfCreateState) {
      let reCreateCount = 0;
      for (let i = 0; i < loginPdfCreateState.files.length; i++) {
        const file = loginPdfCreateState.files[i];
        reCreateCount += file.createCount;
      }
      const FileData: FileData[] = [{
        status: "standBy",
        createCount: reCreateCount,
        firstUserId: loginPdfCreateState.files[0].firstUserId,
        lastUserId: "",
      }];
      loginPdfCreateState = {
        ...loginPdfCreateState,
        tenantId: tenantId!,
        status: "standBy",
        files: FileData,
        createUserUid: currentUser?.uid!,
        createAt: new Date(),
        listFlg: true,
      };
      await systemParametersQuery.updateLoginPdfCreateState(loginPdfCreateState);
      await requestLoginInfoPDFRecreate(loginPdfCreateState.id)
        .catch((reject) => {
          console.error(reject);
          dispatch(alertOpen(AlertValue(ConstMessage.ERR_LOGIN_INFO_PDF_RECREATE, "danger")));
        });
    }
  };

  // ログイン情報PDFダウンロード処理
  const onDownloadPDF = async (filePath:string|undefined, fileName:string|undefined) => {
    if (!filePath || !fileName) return;

    const pdfRef = ref(appStorage, `${filePath}/${fileName}`);

    getDownloadURL(pdfRef).then(downloadUrl => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', downloadUrl, true);
      xhr.responseType = 'blob';

      xhr.onprogress = (event) => {
        if (event.lengthComputable) {
          const progress = Math.floor((event.loaded / event.total) * 100);
          setProgress(progress);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) {
          const blobUrl = URL.createObjectURL(xhr.response);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
          setProgress(100);
        } else {
          dispatch(alertOpen(AlertValue(`ダウンロードに失敗しました: ${fileName}`, "danger")));
        }
      };

      xhr.onerror = () => {
        dispatch(alertOpen(AlertValue(`ダウンロード中にエラーが発生しました: ${fileName}`, "danger")));
      };

      xhr.send();
    }).catch(err => {
      console.log(err);
      dispatch(alertOpen(AlertValue(`ダウンロードURL取得に失敗しました: ${fileName}`, "danger")));
    });
  };

  return (
    <>
      <div className="flex h-full">
        <Progress
          subText={progressSubText}
          open={loadProgress >= 0 && loadProgress < 100}
          progressNum={loadProgress}
          color="green"
        />
        <StaffEditModal
          open={isOpenStaff}
          toggle={toggleStaff}
          closeOnClickOutside={true}
          children={undefined}
          authUser={authUserAndPass}
          updateFlg={isUpdateStaff}
          onSubmit={onSubmitStaff}
        />
        <div className={`relative z-0 flex flex-1 ${isInfoType === "company" ? "" : "flex-row-reverse"}`}>
          <main className={`relative z-0 flex-1 p-6 ${isInfoType === "company" ? "border-r" : "border-l"}`}>
            {isLoadModal ? <div className="justify-center"><Spiner/></div> : (
              <>
                <ModalAndAlmightyDialog
                  toggle={toggleDialog}
                  open={isOpenDialog}
                  title={dialogTitle}
                  children={dialogChildren}
                  actions={dialogActions}
                  height={"72"}
                  closeOnClickOutside={false}
                />
              </>
            )}
            {isLode ? <Spiner/> : (
              <article>
                {isInfoType === "company" ? (
                  <>
                    <MunicipalitiesRef
                      company={company!}
                      userCountList={userCountList}
                    />
                    <div className="flex gap-x-32 mt-8">
                      <div>
                        <h2 className="truncate text-2xl font-bold text-gray-900">{"利用者情報"}</h2>
                        <div className="flex mx-5 mt-1 items-center">
                          <Button
                            className="pl-3 pr-3 ml-2 h-8 w-[88px] flex items-center justify-center text-center"
                            size="sm"
                            color="indigo"
                            onClick={() => onExportAll("xlsx","info")}
                            disabled={isStandBy}
                          >
                            Excel出力
                          </Button>
                          <InputFile
                            id="all"
                            size="sm"
                            color="indigo"
                            multiple={false}
                            disabled={isStandBy}
                            outline
                            className="pl-3 pr-3 ml-2 h-8 flex items-center justify-center text-center"
                            onChange={(e) => {
                              const files = e.target.files;
                              if (files && files[0]) {
                                setTargetFile(files[0]);
                                onImportAll("xlsx", files[0], e);
                              }
                            }}
                          >
                            Excel取込
                          </InputFile>
                          <div className="text-gray-500 mt-1">{isStandBy ? "【契約数更新中】" : ""}</div>
                        </div>
                      </div>
                      {optionFlg.point && (
                        <div>
                          <h2 className="truncate text-2xl font-bold text-gray-900">{"利用者オプション設定"}</h2>
                          <div className="flex mx-5 mt-1 items-center">
                            <Button
                              className="pl-3 pr-3 ml-2 h-8 w-[88px] flex items-center justify-center text-center"
                              size="sm"
                              color="indigo"
                              onClick={async () => {
                                if (await checkOption("point", dispatch)) {
                                  onExportAll("xlsx","option");
                                  }
                                }
                              }
                              disabled={isStandBy}
                            >
                              Excel出力
                            </Button>
                            <Button
                              className={`
                                pl-3 pr-3 ml-2 h-8 flex items-center justify-center text-center
                                border-2 border-indigo-600 !text-indigo-600 bg-white
                                hover:bg-indigo-50
                                active:bg-indigo-500 active:!text-white
                                rounded font-medium shadow transition ease-in duration-200
                              `}
                              outline={true}
                              size="sm"
                              disabled={isStandBy}
                              onClick={async () => {
                                if (await checkOption("point", dispatch)) {
                                  document.getElementById("optionAll")?.click();
                                }
                              }}
                            >
                              Excel取込
                            </Button>

                            <input
                              id="optionAll"
                              type="file"
                              accept=".xlsx"
                              style={{ display: 'none' }}
                              onChange={(e) => {
                                const files = e.target.files;
                                if (files && files[0]) {
                                  setTargetFile(files[0]);
                                  onOptionImportAll("xlsx", files[0], e);
                                }
                              }}
                            />
                            <div className="text-gray-500 mt-1">{isStandBy ? "【契約数更新中】" : ""}</div>
                          </div>
                        </div>
                      )}
                    </div>
                    <h2 className="truncate text-2xl font-bold text-gray-900 mt-8">{"ログイン情報"}</h2>
                    <div className="flex mx-5 mb-4 mt-1 items-center">
                      <Button
                        className="pl-3 pr-3 ml-2 h-8 w-[88px] flex items-center justify-center text-center"
                        size="sm"
                        color="indigo"
                        onClick={() => onCreatePDF("create")}
                        disabled={isStandBy}
                      >
                        PDF出力
                      </Button>
                      <div className="text-gray-500 mt-1">{isStandBy ? "【契約数更新中】" : ""}</div>
                    </div>
                    <div className="text-sm mb-5 ml-6">PDFの出力が完了次第メールでご連絡します</div>
                    <div className={'ml-5 pb-5'}>
                      <TableList header footer={false} gridCol={loginInfoCol} gridRow={loginInfoRow} limit={10} sort={false}/>
                    </div>
                  </>
                ) : (
                  <>
                    <StaffRef value={selectStaff} tenantId={tenantId!} />
                    <div className={'flex justify-end'}>
                      <Button
                        color={"yellow"}
                        size={"sm"}
                        className={`ml-2 ${selectStaff?.emailVerified ? "hidden" : ""}`}
                        onClick={sendMail}
                        children={"メール再送"}
                      />
                      <Button
                        color={"green"}
                        outline
                        size={"sm"}
                        className={`ml-2 ${selectStaff?.emailVerified ? "" : "hidden"}`}
                        onClick={resetPassword}
                        children={"パスワード再設定メール送信"}
                      />
                      <Button
                        size={"sm"}
                        className={"ml-2"}
                        onClick={() => {
                          toggleStaff();
                          setIsUpdateStaff(true);
                        }}
                        children={"編集"}
                      />
                      <Button
                        color={"red"}
                        size={"sm"}
                        className={"ml-2"}
                        onClick={onClickDeleteStaff}
                        children={"削除する"}
                      />
                    </div>
                  </>
                )}
              </article>
            )}
          </main>
          <aside className={"w-72 p-6"}>
            {/* Breadcrumb */}
            <nav className={`flex items-start mb-6 ${isInfoType === 'company' ? "hidden" : ""}`} aria-label="Breadcrumb" >
              <div className="inline-flex items-center text-sm font-medium text-gray-900 cursor-pointer"
                onClick={() => {
                    setIsInfoType("company");
                }}>
                <ChevronLeftIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
                <span>契約情報表示</span>
              </div>
            </nav>
            <Button block onClick={onClickStaffAdd}>
              管理者権限の付与
            </Button>
            <nav
              className="min-h-0 flex-1 overflow-y-auto my-4"
              aria-label="Directory"
            >
              <StackedLists list={rowList} />
            </nav>
          </aside>
        </div>
      </div>
    </>
  );
}
